function floatToString(t, e) {
    var i = t.toFixed(e).toString();
    return i.match(/^\.\d+/) ? "0" + i : i
}

function notifyAddCartFail(t) {
    $(".loading").hide(), $.jGrowl(t, {
        life: 3e3,
        position: "center"
    })
}

/* =====================================================
   GLOBAL CART ADD LISTENER (THIS IS THE KEY)
===================================================== */
function openAddToCartPopup() {
  var layer = document.getElementById("layer-addcart-modal");
  var box   = document.querySelector("#layer-addcart-modal .addcart-modal-box");

  if (!layer || !box) return;

  /* 🔥 FORCE REFLOW (CRITICAL LINE) */
  layer.offsetHeight;

  /* OPEN OVERLAY */
  layer.style.display = "block";
  layer.style.opacity = "1";
  layer.style.visibility = "visible";
  layer.style.zIndex = "9999";

  /* OPEN POPUP BOX */
  box.style.display = "block";
  box.style.opacity = "1";
  box.style.visibility = "visible";
  box.style.pointerEvents = "auto";
}

$(document).ajaxSuccess(function (event, xhr, settings) {

  if (!settings || settings.url !== "/cart/add.js") return;

  // Wait until theme finishes its cart logic
  setTimeout(function () {
    openAddToCartPopup();
  }, 50); // <-- VERY IMPORTANT
});

/* =====================================================
   OPTIONAL: YOUR MANUAL AJAX ADD (SAFE)
===================================================== */
function addToCart(e) {
  if (e) e.preventDefault();

  var $btn  = $(this);
  var $form = $btn.closest("form");

  $btn.addClass("disabled");
  $(".loading").show();

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: $form.serialize(), // selected variant guaranteed
    dataType: "json",
    cache: false,
    error: function (xhr) {
      $(".loading").hide();
      $btn.removeClass("disabled");

      let msg = "Unable to add product to cart.";
      try {
        msg = $.parseJSON(xhr.responseText).description;
      } catch (e) {}
      alert(msg);
    },
    success: function () {
      $(".loading").hide();
      $btn.removeClass("disabled");
      // popup opens via ajaxSuccess (not here)
    }
  });
}

function addToCartSuccess(item) {

  $(".loading").hide();
  $(".product-form__submit").removeClass("disabled");

  if (window.BOLD?.common?.cartDoctor) {
    item = window.BOLD.common.cartDoctor.fixItem(item);
  }

  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      if (window.BOLD?.common?.cartDoctor) {
        cart = window.BOLD.common.cartDoctor.fix(cart);
      }

      Shopify.updateCartInfo(cart, "#cart-info #cart-content");

      const txt =
        cart.item_count === 1
          ? "There is 1 item in your cart."
          : `There are ${cart.item_count} items in your cart.`;

      $(".addcart-modal-number").html(txt);
    });

  const moneyFormat =
    typeof _bc_config !== "undefined" && _bc_config.money_format
      ? _bc_config.money_format
      : "${{amount}}";

  const imageUrl = item.image
    ? item.image.replace(/(\.\w+)$/, "_300x300$1")
    : "";

  $(".addcart-modal-image").html(
    imageUrl ? `<img src="${imageUrl}" alt="${item.title}">` : ""
  );
  $(".addcart-modal-title").html(item.product_title);
  $(".addcart-modal-variant").html(
    item.variant_title ? `Variant: ${item.variant_title}` : ""
  );
  $(".addcart-modal-qty").html(`<strong>Quantity:</strong> ${item.quantity}`);
  $(".addcart-modal-price").html(
    `<strong>Total:</strong> ${Shopify.formatMoney(item.price * item.quantity, moneyFormat)}`
  );
  $(".addcart-modal-options").html(item.properties_formatted || "");

  // ✅ OPEN POPUP LAST
  openAddToCartPopup();
}


function addToCartFail(xhr) {
  $(".loading").hide();
  $(".product-form__submit").removeClass("disabled");

  var errorMsg = "Unable to add product to cart.";
  if (xhr?.responseText) {
    try {
      errorMsg = $.parseJSON(xhr.responseText).description;
    } catch (e) {}
  }

  notifyAddCartFail(`<div class="error">${errorMsg}</div>`);
}

// function addcartModalHide() {
//   var layer = document.getElementById("layer-addcart-modal");
//   var box   = document.querySelector("#layer-addcart-modal .addcart-modal-box");

//   if (box) box.style.display = "none";
//   if (layer) layer.style.display = "none";

//   // 🔥 FORCE FULL RESET
//   setTimeout(function () {
//     window.location.reload();
//   }, 100);
// }
var AT_Slider = {
        owlSlider: function() {
            jQuery(".home-tab-first-slider").length && jQuery(".home-tab-first-slider").on("initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel", function(t) {
                var e = t.relatedTarget.current(),
                    i = $(this).find(".owl-stage").children(),
                    o = "changed" == t.type || "initialized" == t.type;
                i.eq(t.relatedTarget.normalize(e)).toggleClass("current", o)
            }).owlCarousel({
                dots: !0,
                items: 3,
                responsive: {
                    0: {
                        items: 1
                    },
                    480: {
                        items: 2
                    },
                    768: {
                        items: 3
                    }
                }
            }), jQuery(".deals-list").length && jQuery(".deals-list").owlCarousel({
                nav: !0,
                dots: !1,
                items: 1,
                navText: ['<i class="fa fa-angle-left" title="previous">Previous Deal</i>', '<i class="fa fa-angle-right" title="Next">Next Deal</i>']
            }), jQuery(".product-list").length && jQuery(".product-list").on("initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel", function(t) {
                var e = t.relatedTarget.current(),
                    i = $(this).find(".owl-stage").children(),
                    o = "changed" == t.type || "initialized" == t.type;
                i.eq(t.relatedTarget.normalize(e)).toggleClass("current", o)
            }).owlCarousel({
                nav: !0,
                dots: !0,
                items: 4,
                responsive: {
                    0: {
                        items: 1
                    },
                    480: {
                        items: 2
                    },
                    768: {
                        items: 3
                    },
                    1024: {
                        items: 4
                    }
                },
                navText: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
            }), jQuery(".home-tab-third").length && jQuery(".home-tab-third").on("initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel", function(t) {
                var e = t.relatedTarget.current(),
                    i = $(this).find(".owl-stage").children(),
                    o = "changed" == t.type || "initialized" == t.type;
                i.eq(t.relatedTarget.normalize(e)).toggleClass("current", o)
            }).owlCarousel({
                dots: !0,
                items: 2,
                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 2
                    }
                }
            }), jQuery("#widget-partner").length && jQuery("#widget-partner").owlCarousel({
                nav: !0,
                dots: !1,
                items: 5,
                responsive: {
                    0: {
                        items: 2
                    },
                    600: {
                        items: 3
                    },
                    1024: {
                        items: 4
                    },
                    1180: {
                        items: 5
                    }
                },
                navText: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
            }), jQuery(".sb-latest-product-list").length && jQuery(".sb-latest-product-list").owlCarousel({
                nav: !0,
                dots: !1,
                items: 1,
                navText: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
            }), jQuery(".sb-featured-product-list").length && jQuery(".sb-featured-product-list").owlCarousel({
                nav: !0,
                dots: !1,
                items: 1,
                navText: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
            }), jQuery(".sb-post-list").length && jQuery(".sb-post-list").owlCarousel({
                nav: !0,
                dots: !1,
                items: 1,
                navText: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
            }), jQuery("#gallery-image").length && jQuery("#gallery-image").owlCarousel({
                nav: !0,
                dots: !1,
                items: 5,
                margin: 10,
                responsive: {
                    0: {
                        items: 3
                    },
                    480: {
                        items: 4
                    },
                    568: {
                        items: 5
                    },
                    768: {
                        items: 3
                    },
                    1024: {
                        items: 4
                    },
                    1200: {
                        items: 5
                    }
                },
                navText: ['<i class="fa fa-angle-left" title="previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
            }), jQuery(".three-column-list").length && jQuery(".three-column-list").owlCarousel({
                autoplay: !1,
                dots: !1,
                items: 3,
                margin: 30,
                responsive: {
                    0: {
                        items: 1
                    },
                    480: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    }
                }
            })
        },
        init: function() {
            this.owlSlider()
        }
    },
    bcMsieVersion = {
        MsieVersion: function() {
            var t = window.navigator.userAgent,
                e = t.indexOf("MSIE ");
            return e > 0 || navigator.userAgent.match(/Trident.*rv\:11\./) ? parseInt(t.substring(e + 5, t.indexOf(".", e))) : 0
        },
        init: function() {
            this.MsieVersion()
        }
    };
jQuery(document).ready(function(t) {
    AT_Slider.init()
});
var AT_Main = {
    getWidthBrowser: function() {
        var t;
        return "number" == typeof window.innerWidth ? t = window.innerWidth : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? t = document.documentElement.clientWidth : document.body && (document.body.clientWidth || document.body.clientHeight) && (t = document.body.clientWidth), t
    },
    checkLayout: function() {
        return "block" == jQuery("#checkLayout .visible-xs-block").css("display") ? 1 : "block" == jQuery("#checkLayout .visible-sm-block").css("display") ? 2 : "block" == jQuery("#checkLayout .visible-md-block").css("display") ? 3 : "block" == jQuery("#checkLayout .visible-lg-block").css("display") ? 4 : void 0
    },
    homeSlideshow: function() {
        jQuery(".home-slideshow-wrapper").length && jQuery(".home-slideshow-wrapper").each(function(t, e) {
            var i = "";
            jQuery(e).data("autoplay") && (i = jQuery(e).data("time")), new Swiper(".swiper-container", {
                autoplay: i,
                loop: !0,
                pagination: ".swiper-pagination",
                paginationClickable: ".swiper-pagination",
                nextButton: ".swiper-button-next",
                prevButton: ".swiper-button-prev",
                spaceBetween: 0,
                scrollbarDraggable: !0,
                effect: jQuery(e).data("animation"),
                setWrapperSize: !1,
                onImagesReady: function(t) {
                    $(t.container[0]).find(".swiper-slide > img").height(), $(t.container[0]).find(".swiper-slide > img").width(), $(t.container[0]).find(".swiper-slide > img").css("visibility", "hidden"), $(t.container[0]).find(".swiper-slide").each(function() {
                        var t = $(this);
                        t.find(".video-slide").show(), t.find(".video-slide video").css({
                            left: "50%",
                            top: "50%",
                            transform: "translate(-50%,-50%)"
                        })
                    })
                }
            })
        })
    },
    homeIE: function() {
        jQuery(".home-slideshow-wrapper").length && jQuery(".home-slideshow-wrapper").each(function(t, e) {
            var i = "";
            jQuery(e).data("autoplay") && (i = jQuery(e).data("time")), new Swiper(".swiper-container", {
                autoplay: i,
                loop: !0,
                pagination: ".swiper-pagination",
                paginationClickable: ".swiper-pagination",
                nextButton: ".swiper-button-next",
                prevButton: ".swiper-button-prev",
                spaceBetween: 30,
                scrollbarDraggable: !0,
                effect: "fade",
                setWrapperSize: !0,
                onImagesReady: function(t) {
                    $(t.container[0]).find(".swiper-slide > img").height(), $(t.container[0]).find(".swiper-slide > img").width(), $(t.container[0]).find(".swiper-slide > img").css("visibility", "hidden"), $(t.container[0]).find(".swiper-slide").each(function() {
                        var t = $(this);
                        t.find(".video-slide").show(), t.find(".video-slide video").css({
                            left: "50%",
                            top: "50%",
                            transform: "translate(-50%,-50%)"
                        })
                    })
                }
            })
        })
    },
    stickMenu: function() {
        if (jQuery(".header-content").data("stick")) {
            var t = 0,
                e = jQuery(".header-middle"),
                i = jQuery("#body-content");
            jQuery(window).scroll(function() {
                var o = jQuery(this).scrollTop();
                o > t ? o > 250 && (e.addClass("header-fixed fadeIn animated"), i.addClass("has-header-fixed")) : 250 > o && (e.removeClass("header-fixed fadeIn animated"), i.removeClass("has-header-fixed")), t = o
            })
        }
    },
    toTopButton: function() {
        var t = $("#scroll-to-top");
        1 > t.length || ($(window).on("scroll", function() {
            var t = jQuery(this).scrollTop(),
                e = jQuery(this).height();
            if (t > 100) i = t + e / 2;
            else var i = 1;
            1e3 > i && e > i ? jQuery("#scroll-to-top").removeClass("on off").addClass("off") : jQuery("#scroll-to-top").removeClass("on off").addClass("on")
        }), t.on("click", function(t) {
            t.preventDefault(), jQuery("body,html").animate({
                scrollTop: 0
            }, 800, "swing")
        }))
    },
    mailchipPopup: function() {
        var t = jQuery("#mailchimp-popup").data("expires");
        jQuery.cookie("mycookie") || jQuery.fancybox(jQuery("#mailchimp-popup"), {
            autoDimensions: !1,
            width: 730,
            height: 390,
            autoSize: !1,
            transitionIn: "none",
            transitionOut: "none"
        }), jQuery.cookie("mycookie", "true", {
            expires: t
        })
    },
    handleGridList: function() {
        "yes" == $.cookie("cata-grid-extended") && $("body").addClass("cata-grid-extended"), "yes" == $.cookie("cata-list") && $("body").addClass("cata-list"), "yes" == $.cookie("cata-list-small") && $("body").addClass("cata-list-small"), jQuery("body").on("click", ".grid", function() {
            jQuery(this).closest(".grid-list"), $.cookie("cata-grid-extended", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list-small", "no", {
                expires: 1,
                path: "/"
            }), jQuery("body").removeClass("cata-grid-extended"), jQuery("body").removeClass("cata-list"), jQuery("body").removeClass("cata-list-small")
        }), jQuery("body").on("click", ".grid-extended", function() {
            jQuery(this).closest(".grid-list"), $.cookie("cata-list", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list-small", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-grid-extended", "yes", {
                expires: 1,
                path: "/"
            }), jQuery("body").removeClass("cata-list"), jQuery("body").removeClass("cata-list-small"), jQuery("body").addClass("cata-grid-extended")
        }), jQuery("body").on("click", ".list", function() {
            jQuery(this).closest(".grid-list"), $.cookie("cata-grid-extended", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list-small", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list", "yes", {
                expires: 1,
                path: "/"
            }), jQuery("body").removeClass("cata-grid-extended"), jQuery("body").removeClass("cata-list-small"), jQuery("body").addClass("cata-list")
        }), jQuery("body").on("click", ".list-small", function() {
            jQuery(this).closest(".grid-list"), $.cookie("cata-grid-extended", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list-small", "yes", {
                expires: 1,
                path: "/"
            }), jQuery("body").removeClass("cata-grid-extended"), jQuery("body").removeClass("cata-list"), jQuery("body").addClass("cata-list-small")
        })
    },
    effectNavigation: function() {
        jQuery(".horizontal-menu .navigation .navbar-collapse .main-nav>li").hover(function(t) {
            jQuery(this).find(">.dropdown-menu, >.dropdown-menu li >.dropdown-menu").addClass("fadeInUp animated")
        }, function(t) {
            jQuery(this).find(">.dropdown-menu, >.dropdown-menu li >.dropdown-menu").removeClass("fadeInUp animated")
        }), jQuery(".vertical-menu .navigation .navbar-collapse .main-nav>li").hover(function(t) {
            jQuery(this).find(">.dropdown-menu, >.dropdown-menu li >.dropdown-menu").addClass("fadeInRight animated")
        }, function(t) {
            jQuery(this).find(">.dropdown-menu, >.dropdown-menu li >.dropdown-menu").removeClass("fadeInRight animated")
        }), jQuery(".cart-target").hover(function(t) {
            jQuery(this).find(">.dropdown-menu").addClass("fadeInUp animated")
        }, function(t) {
            jQuery(this).find(">.dropdown-menu").removeClass("fadeInUp animated")
        }), jQuery(".currency-block").hover(function(t) {
            jQuery(this).find(">.dropdown-menu").addClass("fadeInUp animated")
        }, function(t) {
            jQuery(this).find(">.dropdown-menu").removeClass("fadeInUp animated")
        })
    },
    fancyboxHomeThumbProduct: function() {
        jQuery(".thumb-item-img").fancybox({
            prevEffect: "none",
            nextEffect: "none",
            closeBtn: !1,
            helpers: {
                title: {
                    type: "inside"
                },
                buttons: {}
            }
        })
    },
    fixNoScroll: function() {
        var t = jQuery(window).width();
        jQuery("#page-body, .header-content, #page-body .mobile-version").css("width", t + "px")
    },
    fixReturnScroll: function() {
        jQuery("#page-body, .header-content,#page-body .mobile-version").attr("style", "")
    },
    fixButton: function() {
        jQuery(".product-wrapper .product-head").each(function(t) {
            $(this).children().hasClass("wrapper-countdown") && $(this).find(".product-button").addClass("fix")
        })
    },
    handleReviews: function() {
        SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
    },
    menuOnMobile: function() {
        jQuery("#page-body").on("click", function() {
            jQuery(".menu-mobile").removeClass("opened"), jQuery("html,body").removeClass("menu-opened"), AT_Main.fixReturnScroll()
        }), jQuery(document).on("click", "[data-toggle=offcanvas]", function(t) {
            t.stopPropagation(), AT_Main.fixNoScroll(), jQuery(".menu-mobile").toggleClass("opened"), jQuery("html,body").toggleClass("menu-opened")
        }), jQuery(".navbar .main-nav li").hover(function() {
            jQuery(this).addClass("hover")
        }, function() {
            jQuery(this).removeClass("hover")
        }), jQuery(document).on("click", ".mobile-version .menu-mobile .main-nav .expand", function() {
            var t = jQuery(this).parents(".dropdown").first();
            t.hasClass("menu-mobile-open") ? (t.removeClass("menu-mobile-open"), $(this).find(".visible-xs").removeClass("fa-minus"), $(this).find(".visible-xs").addClass("fa-plus")) : (t.addClass("menu-mobile-open"), $(this).find(".visible-xs").removeClass("fa-plus"), $(this).find(".visible-xs").addClass("fa-minus"))
        }), jQuery(document).on("click", ".sb-categories .s-expand", function() {
            var t = jQuery(this).parents(".dropdown").first();
            t.hasClass("s-open") ? (t.removeClass("s-open"), $(this).find(".s-plus").removeClass("fa-angle-up"), $(this).find(".s-plus").addClass("fa-angle-right")) : (t.addClass("s-open"), $(this).find(".s-plus").removeClass("fa-angle-right"), $(this).find(".s-plus").addClass("fa-angle-up"))
        })
    },
    handleMenuMultiLine: function() {
        var t = "",
            e = !1;
        jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(i) {
            var o = jQuery(i.currentTarget);
            e && "" != t ? (t.addClass("hold"), setTimeout(function() {
                "" != t && t.removeClass("hold"), e = !1, t = ""
            }, 500), (t[0] == o[0] || t.offset().top == o.offset().top) && (t.removeClass("hold"), e = !1, t = "")) : t = ""
        }), jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(i) {
            var o = jQuery(i.currentTarget);
            i.pageY >= o.offset().top + 50 && (e = !0), o.hasClass("dropdown") && "" == t && (t = o)
        })
    },
    toggleFilterSidebar: function() {
        jQuery(document).on("click", ".filter-toggle", function(t) {
            t.stopPropagation(), AT_Main.fixNoScroll(), jQuery(".sbw-filter").toggleClass("opened"), jQuery("html,body").toggleClass("filter-opened")
        }), jQuery(document).on("click", "#page-body", function(t) {
            jQuery(".sbw-filter").removeClass("opened"), jQuery("html,body").removeClass("filter-opened")
        })
    },
    dropdownFilter: function() {
        jQuery(document).on("click", ".sb-filter .sbf-title>span", function(t) {
            t.stopPropagation(), jQuery(this).toggleClass("none-active"), jQuery(this).closest(".sb-filter").find(".advanced-filters").toggleClass("hide")
        })
    },
    toggleFooter: function() {
        jQuery(document).on("click", ".footer-block h3>span", function(t) {
          // console.log("Footer button is clicked");
            jQuery(this).closest(".footer-block").find("h3").toggleClass("opened"), jQuery(this).closest(".footer-block").find(".list-links").slideToggle()
        })
    },
    toggleVerticalMenu: function() {
        jQuery(document).on("click", ".vertical-menu .head", function(t) {
            jQuery(this).parent().toggleClass("opened"), jQuery(this).parent().find(".navbar").slideToggle()
        })
    },
    fixTitle: function() {
        jQuery(".rt a").attr("data-title", function() {
            return jQuery(this).attr("title")
        }), jQuery(".rt a").removeAttr("title")
    },
    filterCatalogReplace: function() {
        var t = collectionUrl.substring(collectionUrl.lastIndexOf("/") + 1),
            e = t.substring(t.lastIndexOf("?"));
        collectionUrl = collectionUrl.replace(t, "");
        var i = (t = (t = t.replace(e, "")).replace("#", "")).split("+"),
            o = [];
        for (jQuery("#" + filter_id + " li.active-filter").each(function() {
                o.push(jQuery(this).attr("data-handle"))
            }), jQuery("#" + filter_id + " li.active-filter").find("a").attr("title", ""), jQuery("#" + filter_id + " li").removeClass("active-filter"), jQueryi = 0; jQueryi < o.length; jQueryi++) i = jQuery.grep(i, function(t, e) {
            return t !== o[jQueryi]
        });
        var n = i.join("+"),
            s = collectionUrl + n + e;
        window.location = s
    },
    filterCatalog: function() {
        var t = jQuery(".advanced-filter");
        t.each(function() {
            var t = jQuery(this);
            t.data("group"), t.hasClass("active-filter") && t.parents(".sb-filter").find("a.clear-filter").removeClass("hidden")
        }), t.on("click", function() {
            var t = jQuery(this);
            t.data("group"), t.find("a").attr("href"), t.hasClass("active-filter")
        }), jQuery(".sb-filter").on("click", ".clear-filter", function(t) {
            var e = jQuery(this).attr("id");
            e = e.replace("clear-", "");
            var i = window.location.href;
            if (i.match(/\?/)) {
                var o = i.substring(i.lastIndexOf("?") - 1);
                if (o.match(/\//)) {
                    var n = o.replace(/\//, "");
                    i = i.replace(o, ""), i += n, AT_Main.filterCatalogReplace()
                } else AT_Main.filterCatalogReplace()
            } else {
                var s = i.substring(i.lastIndexOf("/") + 1);
                i = i.replace(s, "");
                var a = (s = s.replace("#", "")).split("+"),
                    r = [];
                for (jQuery("#" + e + " li.active-filter").each(function() {
                        r.push(jQuery(this).attr("data-handle"))
                    }), jQuery("#" + e + " li.active-filter").find("a").attr("title", ""), jQuery("#" + e + " li").removeClass("active-filter"), jQueryi = 0; jQueryi < r.length; jQueryi++) a = jQuery.grep(a, function(t, e) {
                    return t !== r[jQueryi]
                });
                var l = i + a.join("+");
                window.location = l
            }
        })
    },
    swatch: function() {
        jQuery(".swatch :radio").change(function() {
            var t = jQuery(this).closest(".swatch").attr("data-option-index"),
                e = jQuery(this).val();
            jQuery(this).closest("form").find(".single-option-selector").eq(t).val(e).trigger("change")
        })
    },
    refreshImage: function() {
        jQuery("#gallery-image").length && jQuery("#product-image").on("click", ".thumb-img", function() {
            var t = jQuery(this);
            if (!t.hasClass("active")) {
                var e = t.parents(".product-image-inner"),
                    i = t.attr("data-zoom-image"),
                    o = t.attr("data-image");
                e.find(".thumb-img").removeClass("active"), t.addClass("active"), e.find(".featured-image").find("img").attr("data-zoom-image", i), e.find(".featured-image").find("img").attr("src", o)
            }
            return !1
        })
    },
    refreshZoom: function() {
        jQuery(".featured-image").data("zoom"), jQuery(".elevatezoom").length && (jQuery(".elevatezoom .zoom-image").elevateZoom({
            gallery: "gallery-image",
            galleryActiveClass: "active",
            zoomType: "lens",
            cursor: "pointer",
            lensShape: "round",
            lensSize: 300
        }), jQuery(".elevatezoom").bind("click", function(t) {
            var e = jQuery(".elevatezoom .zoom-image").data("elevateZoom");
            return jQuery.fancybox(e.getGalleryList(), {
                closeBtn: !1,
                helpers: {
                    buttons: {}
                }
            }), !1
        }))
    },
    cartJS_handle: function() {
        rivets.bind(jQuery(".templateCart #cartform, .cart-right, .page-cart .cart-empty-wrapper, #cart-content"), {
            cart: CartJS.cart
        }), "undefined" != typeof _bc_config && ("true" == _bc_config.enable_multiple_currencies && setTimeout(function() {
            Currency.convertAll("USD", Currency.currentCurrency)
        }, 50), jQuery(document).on("cart.requestComplete", function(t, e) {
            Shopify.onCartUpdate(CartJS.cart), "undefined" != typeof _bc_config && "true" == _bc_config.enable_multiple_currencies && Currency.convertAll("USD", Currency.currentCurrency)
        }))
    },
    scareName: function() {
        var t = 0;
        jQuery(".product-wrapper").find("h5.product-name").each(function(e, i) {
            t = jQuery(i).height() > t ? jQuery(i).height() : t
        }), jQuery(".product-wrapper").find("h5.product-name").css("height", t)
    },
    scareScreen: function() {
        if ("undefined" != typeof _bc_config) {
            var t = this;
            "true" == _bc_config.enable_title_blance && this.scareName(), jQuery(document).ajaxComplete(function(e, i, o) {
                "true" == _bc_config.enable_title_blance && t.scareName()
            })
        }
    },
    init: function() {
        return "undefined" == typeof _bc_config ? void console.log(" _bc_config is undefined ") : (this.stickMenu(), this.toTopButton(), this.mailchipPopup(), this.effectNavigation(), this.handleGridList(), this.fancyboxHomeThumbProduct(), this.fixButton(), this.menuOnMobile(), this.handleMenuMultiLine(), this.toggleFilterSidebar(), this.toggleFooter(), this.toggleVerticalMenu(), this.dropdownFilter(), this.fixTitle(), this.filterCatalog(), this.swatch(), this.refreshImage(), this.refreshZoom(), this.cartJS_handle(), void this.scareScreen())
    }
};
if (jQuery(window).resize(function() {
        AT_Main.getWidthBrowser() < 1024 && jQuery("#top").hasClass("on") && (jQuery("#top").prev().remove(), jQuery("#top").removeClass("on").removeClass("animated")), AT_Main.fixReturnScroll(), 1 != AT_Main.checkLayout() && jQuery(".menu-mobile").hasClass("opened") && jQuery("#page-body").trigger("click")
    }), jQuery(document).ready(function(t) {
        jQuery(".templateCart #qs-add-cart").click(function(t) {
            setTimeout(function() {
                window.location.reload()
            }, 2e3)
        }), AT_Main.init()
    }), void 0 === Shopify) var Shopify = {};
Shopify.each = function(t, e) {
        for (var i = 0; i < t.length; i++) e(t[i], i)
    }, Shopify.map = function(t, e) {
        for (var i = [], o = 0; o < t.length; o++) i.push(e(t[o], o));
        return i
    }, Shopify.arrayIncludes = function(t, e) {
        for (var i = 0; i < t.length; i++)
            if (t[i] == e) return !0;
        return !1
    }, Shopify.uniq = function(t) {
        for (var e = [], i = 0; i < t.length; i++) Shopify.arrayIncludes(e, t[i]) || e.push(t[i]);
        return e
    }, Shopify.isDefined = function(t) {
        return void 0 !== t
    }, Shopify.getClass = function(t) {
        return Object.prototype.toString.call(t).slice(8, -1)
    }, Shopify.extend = function(t, e) {
        function i() {}
        i.prototype = e.prototype, t.prototype = new i, t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype
    }, Shopify.urlParam = function(t) {
        var e = RegExp("[?&]" + t + "=([^&]*)").exec(window.location.search);
        return e && decodeURIComponent(e[1].replace(/\+/g, " "))
    }, Shopify.Product = function(t) {
        Shopify.isDefined(t) && this.update(t)
    }, Shopify.Product.prototype.update = function(t) {
        for (property in t) this[property] = t[property]
    }, Shopify.Product.prototype.optionNames = function() {
        return "Array" == Shopify.getClass(this.options) ? this.options : []
    }, Shopify.Product.prototype.optionValues = function(t) {
        if (!Shopify.isDefined(this.variants)) return null;
        var e = Shopify.map(this.variants, function(e) {
            var i = "option" + (t + 1);
            return void 0 == e[i] ? null : e[i]
        });
        return null == e[0] ? null : Shopify.uniq(e)
    }, Shopify.Product.prototype.getVariant = function(t) {
        var e = null;
        return t.length != this.options.length ? e : (Shopify.each(this.variants, function(i) {
            for (var o = !0, n = 0; n < t.length; n++) i["option" + (n + 1)] != t[n] && (o = !1);
            return 1 == o ? void(e = i) : void 0
        }), e)
    }, Shopify.Product.prototype.getVariantById = function(t) {
        for (var e = 0; e < this.variants.length; e++) {
            var i = this.variants[e];
            if (t == i.id) return i
        }
        return null
    }, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function(t, e) {
        function i(t, e) {
            return void 0 === t ? e : t
        }

        function o(t, e, o, n) {
            if (e = i(e, 2), o = i(o, ","), n = i(n, "."), isNaN(t) || null == t) return 0;
            var s = (t = (t / 100).toFixed(e)).split(".");
            return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (s[1] ? n + s[1] : "")
        }
        "string" == typeof t && (t = t.replace(".", ""));
        var n = "",
            s = /\{\{\s*(\w+)\s*\}\}/,
            a = e || this.money_format;
        switch (a.match(s)[1]) {
            case "amount":
                n = o(t, 2);
                break;
            case "amount_no_decimals":
                n = o(t, 0);
                break;
            case "amount_with_comma_separator":
                n = o(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = o(t, 0, ".", ",")
        }
        return a.replace(s, n)
    }, Shopify.OptionSelectors = function(t, e) {
        return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
    }, Shopify.OptionSelectors.prototype.initDropdown = function() {
        var t = {
            initialLoad: !0
        };
        if (!this.selectVariantFromDropdown(t)) {
            var e = this;
            setTimeout(function() {
                e.selectVariantFromParams(t) || e.fireOnChangeForFirstDropdown.call(e, t)
            })
        }
    }, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
        this.selectors[0].element.onchange(t)
    }, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
        this.selectVariantFromParams(t) || this.selectVariantFromDropdown(t)
    }, Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
        var e = document.getElementById(t),
            i = e.parentNode;
        Shopify.each(this.buildSelectors(), function(t) {
            i.insertBefore(t, e)
        }), e.style.display = "none", this.variantIdField = e
    }, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
        var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
        if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1;
        var i = e.value;
        return this.selectVariant(i, t)
    }, Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
        var e = Shopify.urlParam("variant");
        return this.selectVariant(e, t)
    }, Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
        var i = this.product.getVariantById(t);
        if (null == i) return !1;
        for (var o = 0; o < this.selectors.length; o++) {
            var n = this.selectors[o].element,
                s = i[n.getAttribute("data-option")];
            null != s && this.optionExistInSelect(n, s) && (n.value = s)
        }
        return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0
    }, Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
        for (var i = 0; i < t.options.length; i++)
            if (t.options[i].value == e) return !0
    }, Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
        Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
        var i = document.getElementById(t);
        Shopify.each(this.buildSelectors(), function(t) {
            i.appendChild(t)
        })
    }, Shopify.OptionSelectors.prototype.buildSelectors = function() {
        for (var t = 0; t < this.product.optionNames().length; t++) {
            var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
            e.element.disabled = !1, this.selectors.push(e)
        }
        var i = this.selectorDivClass,
            o = this.product.optionNames();
        return Shopify.map(this.selectors, function(t) {
            var e = document.createElement("div"),
                n = i;
            if (void 0 !== t.name) {
                var s = t.name.name || t.name;
                n = i + " " + s.toLowerCase().replace(" ", "_")
            }
            if (e.setAttribute("class", n), o.length > 1) {
                var a = document.createElement("label");
                a.htmlFor = t.element.id, a.innerHTML = t.name.name || t.name, e.appendChild(a)
            }
            return e.appendChild(t.element), e
        })
    }, Shopify.OptionSelectors.prototype.selectedValues = function() {
        for (var t = [], e = 0; e < this.selectors.length; e++) {
            var i = this.selectors[e].element.value;
            t.push(i)
        }
        return t
    }, Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
        var i = this.selectedValues(),
            o = this.product.getVariant(i);
        o ? (this.variantIdField.disabled = !1, this.variantIdField.value = o.id) : this.variantIdField.disabled = !0, this.onVariantSelected(o, this, e), null != this.historyState && this.historyState.onVariantChange(o, this, e)
    }, Shopify.OptionSelectorsFromDOM = function(t, e) {
        var i = e.optionNames || [],
            o = e.priceFieldExists || !0,
            n = e.delimiter || "/",
            s = this.createProductFromSelector(t, i, o, n);
        e.product = s, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
    }, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, i, o) {
        if (!Shopify.isDefined(i)) var i = !0;
        if (!Shopify.isDefined(o)) var o = "/";
        var n = document.getElementById(t),
            s = n.childNodes,
            a = (n.parentNode, e.length),
            r = [];
        Shopify.each(s, function(t) {
            if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
                var n = t.innerHTML.split(new RegExp("\\s*\\" + o + "\\s*"));
                0 == e.length && (a = n.length - (i ? 1 : 0));
                var s = n.slice(0, a),
                    l = i ? n[a] : "",
                    h = (t.getAttribute("value"), {
                        available: !t.disabled,
                        id: parseFloat(t.value),
                        price: l,
                        option1: s[0],
                        option2: s[1],
                        option3: s[2]
                    });
                r.push(h)
            }
        });
        var l = {
            variants: r
        };
        if (0 == e.length) {
            l.options = [];
            for (var h = 0; a > h; h++) l.options[h] = "option " + (h + 1)
        } else l.options = e;
        return l
    }, Shopify.SingleOptionSelector = function(t, e, i, o) {
        this.multiSelector = t, this.values = o, this.index = e, this.name = i, this.element = document.createElement("select");
        for (var n = 0; n < o.length; n++) {
            var s = document.createElement("option");
            s.value = o[n], s.innerHTML = o[n], this.element.appendChild(s)
        }
        return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function(i, o) {
            o = o || {}, t.updateSelectors(e, o)
        }, !0
    }, Shopify.Image = {
        preload: function(t, e) {
            for (var i = 0; i < t.length; i++) {
                var o = t[i];
                this.loadImage(this.getSizedImageUrl(o, e))
            }
        },
        loadImage: function(t) {
            (new Image).src = t
        },
        switchImage: function(t, e, i) {
            if (t && e) {
                var o = this.imageSize(e.src),
                    n = this.getSizedImageUrl(t.src, o);
                i ? i(n, t, e) : e.src = n
            }
        },
        imageSize: function(t) {
            var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
            return null != e ? e[1] : null
        },
        getSizedImageUrl: function(t, e) {
            if (null == e) return t;
            if ("master" == e) return this.removeProtocol(t);
            var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null != i) {
                var o = t.split(i[0]),
                    n = i[0];
                return this.removeProtocol(o[0] + "_" + e + n)
            }
            return null
        },
        removeProtocol: function(t) {
            return t.replace(/http(s)?:/, "")
        }
    }, Shopify.OptionSelectors.HistoryState = function(t) {
        this.browserSupports() && this.register(t)
    }, Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
        window.addEventListener("popstate", function() {
            t.selectVariantFromParamsOrDropdown({
                popStateCall: !0
            })
        })
    }, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, i) {
        this.browserSupports() && (!t || i.initialLoad || i.popStateCall || window.history.replaceState({}, document.title, "?variant=" + t.id))
    }, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
        return window.history && window.history.replaceState
    },
    function(t) {
        function e() {}
        for (var i, o = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","); i = o.pop();) t[i] = t[i] || e
    }(function() {
        try {
            return console.log(), window.console
        } catch (t) {
            return window.console = {}
        }
    }());
var g = {
        common: {
            init: function() {
                $("body").on("click", ".quick_shop", addToCart)
            }
        },
        templateIndex: {
            init: function() {}
        },
        templateProduct: {
            init: function() {}
        },
        templateCart: {
            init: function() {}
        }
    },
    u = {
        fire: function(t, e, i) {
            var o = g;
            e = void 0 === e ? "init" : e, "" !== t && o[t] && "function" == typeof o[t][e] && o[t][e](i)
        },
        loadEvents: function() {
            var t = document.body.id;
            u.fire("common"), $.each(document.body.className.split(/\s+/), function(e, i) {
                u.fire(i), u.fire(i, t)
            })
        }
    };
if ($(document).ready(u.loadEvents), "undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery"); + function(t) {
    "use strict";
    var e = t.fn.jquery.split(" ")[0].split(".");
    if (e[0] < 2 && e[1] < 9 || 1 == e[0] && 9 == e[1] && e[2] < 1) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher")
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        return this.each(function() {
            var i = t(this),
                n = i.data("bs.alert");
            n || i.data("bs.alert", n = new o(this)), "string" == typeof e && n[e].call(i)
        })
    }
    var i = '[data-dismiss="alert"]',
        o = function(e) {
            t(e).on("click", i, this.close)
        };
    o.VERSION = "3.3.2", o.TRANSITION_DURATION = 150, o.prototype.close = function(e) {
        function i() {
            a.detach().trigger("closed.bs.alert").remove()
        }
        var n = t(this),
            s = n.attr("data-target");
        s || (s = n.attr("href"), s = s && s.replace(/.*(?=#[^\s]*$)/, ""));
        var a = t(s);
        e && e.preventDefault(), a.length || (a = n.closest(".alert")), a.trigger(e = t.Event("close.bs.alert")), e.isDefaultPrevented() || (a.removeClass("in"), t.support.transition && a.hasClass("fade") ? a.one("bsTransitionEnd", i).emulateTransitionEnd(o.TRANSITION_DURATION) : i())
    };
    var n = t.fn.alert;
    t.fn.alert = e, t.fn.alert.Constructor = o, t.fn.alert.noConflict = function() {
        return t.fn.alert = n, this
    }, t(document).on("click.bs.alert.data-api", i, o.prototype.close)
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        return this.each(function() {
            var o = t(this),
                n = o.data("bs.button"),
                s = "object" == typeof e && e;
            n || o.data("bs.button", n = new i(this, s)), "toggle" == e ? n.toggle() : e && n.setState(e)
        })
    }
    var i = function(e, o) {
        this.$element = t(e), this.options = t.extend({}, i.DEFAULTS, o), this.isLoading = !1
    };
    i.VERSION = "3.3.2", i.DEFAULTS = {
        loadingText: "loading..."
    }, i.prototype.setState = function(e) {
        var i = "disabled",
            o = this.$element,
            n = o.is("input") ? "val" : "html",
            s = o.data();
        e += "Text", null == s.resetText && o.data("resetText", o[n]()), setTimeout(t.proxy(function() {
            o[n](null == s[e] ? this.options[e] : s[e]), "loadingText" == e ? (this.isLoading = !0, o.addClass(i).attr(i, i)) : this.isLoading && (this.isLoading = !1, o.removeClass(i).removeAttr(i))
        }, this), 0)
    }, i.prototype.toggle = function() {
        var t = !0,
            e = this.$element.closest('[data-toggle="buttons"]');
        if (e.length) {
            var i = this.$element.find("input");
            "radio" == i.prop("type") && (i.prop("checked") && this.$element.hasClass("active") ? t = !1 : e.find(".active").removeClass("active")), t && i.prop("checked", !this.$element.hasClass("active")).trigger("change")
        } else this.$element.attr("aria-pressed", !this.$element.hasClass("active"));
        t && this.$element.toggleClass("active")
    };
    var o = t.fn.button;
    t.fn.button = e, t.fn.button.Constructor = i, t.fn.button.noConflict = function() {
        return t.fn.button = o, this
    }, t(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(i) {
        var o = t(i.target);
        o.hasClass("btn") || (o = o.closest(".btn")), e.call(o, "toggle"), i.preventDefault()
    }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(e) {
        t(e.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(e.type))
    })
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        return this.each(function() {
            var o = t(this),
                n = o.data("bs.carousel"),
                s = t.extend({}, i.DEFAULTS, o.data(), "object" == typeof e && e),
                a = "string" == typeof e ? e : s.slide;
            n || o.data("bs.carousel", n = new i(this, s)), "number" == typeof e ? n.to(e) : a ? n[a]() : s.interval && n.pause().cycle()
        })
    }
    var i = function(e, i) {
        this.$element = t(e), this.$indicators = this.$element.find(".carousel-indicators"), this.options = i, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", t.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", t.proxy(this.pause, this)).on("mouseleave.bs.carousel", t.proxy(this.cycle, this))
    };
    i.VERSION = "3.3.2", i.TRANSITION_DURATION = 600, i.DEFAULTS = {
        interval: 5e3,
        pause: "hover",
        wrap: !0,
        keyboard: !0
    }, i.prototype.keydown = function(t) {
        if (!/input|textarea/i.test(t.target.tagName)) {
            switch (t.which) {
                case 37:
                    this.prev();
                    break;
                case 39:
                    this.next();
                    break;
                default:
                    return
            }
            t.preventDefault()
        }
    }, i.prototype.cycle = function(e) {
        return e || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(t.proxy(this.next, this), this.options.interval)), this
    }, i.prototype.getItemIndex = function(t) {
        return this.$items = t.parent().children(".item"), this.$items.index(t || this.$active)
    }, i.prototype.getItemForDirection = function(t, e) {
        var i = this.getItemIndex(e);
        if (("prev" == t && 0 === i || "next" == t && i == this.$items.length - 1) && !this.options.wrap) return e;
        var o = (i + ("prev" == t ? -1 : 1)) % this.$items.length;
        return this.$items.eq(o)
    }, i.prototype.to = function(t) {
        var e = this,
            i = this.getItemIndex(this.$active = this.$element.find(".item.active"));
        return t > this.$items.length - 1 || 0 > t ? void 0 : this.sliding ? this.$element.one("slid.bs.carousel", function() {
            e.to(t)
        }) : i == t ? this.pause().cycle() : this.slide(t > i ? "next" : "prev", this.$items.eq(t))
    }, i.prototype.pause = function(e) {
        return e || (this.paused = !0), this.$element.find(".next, .prev").length && t.support.transition && (this.$element.trigger(t.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
    }, i.prototype.next = function() {
        return this.sliding ? void 0 : this.slide("next")
    }, i.prototype.prev = function() {
        return this.sliding ? void 0 : this.slide("prev")
    }, i.prototype.slide = function(e, o) {
        var n = this.$element.find(".item.active"),
            s = o || this.getItemForDirection(e, n),
            a = this.interval,
            r = "next" == e ? "left" : "right",
            l = this;
        if (s.hasClass("active")) return this.sliding = !1;
        var h = s[0],
            d = t.Event("slide.bs.carousel", {
                relatedTarget: h,
                direction: r
            });
        if (this.$element.trigger(d), !d.isDefaultPrevented()) {
            if (this.sliding = !0, a && this.pause(), this.$indicators.length) {
                this.$indicators.find(".active").removeClass("active");
                var c = t(this.$indicators.children()[this.getItemIndex(s)]);
                c && c.addClass("active")
            }
            var p = t.Event("slid.bs.carousel", {
                relatedTarget: h,
                direction: r
            });
            return t.support.transition && this.$element.hasClass("slide") ? (s.addClass(e), s[0].offsetWidth, n.addClass(r), s.addClass(r), n.one("bsTransitionEnd", function() {
                s.removeClass([e, r].join(" ")).addClass("active"), n.removeClass(["active", r].join(" ")), l.sliding = !1, setTimeout(function() {
                    l.$element.trigger(p)
                }, 0)
            }).emulateTransitionEnd(i.TRANSITION_DURATION)) : (n.removeClass("active"), s.addClass("active"), this.sliding = !1, this.$element.trigger(p)), a && this.cycle(), this
        }
    };
    var o = t.fn.carousel;
    t.fn.carousel = e, t.fn.carousel.Constructor = i, t.fn.carousel.noConflict = function() {
        return t.fn.carousel = o, this
    };
    var n = function(i) {
        var o, n = t(this),
            s = t(n.attr("data-target") || (o = n.attr("href")) && o.replace(/.*(?=#[^\s]+$)/, ""));
        if (s.hasClass("carousel")) {
            var a = t.extend({}, s.data(), n.data()),
                r = n.attr("data-slide-to");
            r && (a.interval = !1), e.call(s, a), r && s.data("bs.carousel").to(r), i.preventDefault()
        }
    };
    t(document).on("click.bs.carousel.data-api", "[data-slide]", n).on("click.bs.carousel.data-api", "[data-slide-to]", n), t(window).on("load", function() {
        t('[data-ride="carousel"]').each(function() {
            var i = t(this);
            e.call(i, i.data())
        })
    })
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        e && 3 === e.which || (t(n).remove(), t(s).each(function() {
            var o = t(this),
                n = i(o),
                s = {
                    relatedTarget: this
                };
            n.hasClass("open") && (n.trigger(e = t.Event("hide.bs.dropdown", s)), e.isDefaultPrevented() || (o.attr("aria-expanded", "false"), n.removeClass("open").trigger("hidden.bs.dropdown", s)))
        }))
    }

    function i(e) {
        var i = e.attr("data-target");
        i || (i = e.attr("href"), i = i && /#[A-Za-z]/.test(i) && i.replace(/.*(?=#[^\s]*$)/, ""));
        var o = i && t(i);
        return o && o.length ? o : e.parent()
    }

    function o(e) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.dropdown");
            o || i.data("bs.dropdown", o = new a(this)), "string" == typeof e && o[e].call(i)
        })
    }
    var n = ".dropdown-backdrop",
        s = '[data-toggle="dropdown"]',
        a = function(e) {
            t(e).on("click.bs.dropdown", this.toggle)
        };
    a.VERSION = "3.3.2", a.prototype.toggle = function(o) {
        var n = t(this);
        if (!n.is(".disabled, :disabled")) {
            var s = i(n),
                a = s.hasClass("open");
            if (e(), !a) {
                "ontouchstart" in document.documentElement && !s.closest(".navbar-nav").length && t('<div class="dropdown-backdrop"/>').insertAfter(t(this)).on("click", e);
                var r = {
                    relatedTarget: this
                };
                if (s.trigger(o = t.Event("show.bs.dropdown", r)), o.isDefaultPrevented()) return;
                n.trigger("focus").attr("aria-expanded", "true"), s.toggleClass("open").trigger("shown.bs.dropdown", r)
            }
            return !1
        }
    }, a.prototype.keydown = function(e) {
        if (/(38|40|27|32)/.test(e.which) && !/input|textarea/i.test(e.target.tagName)) {
            var o = t(this);
            if (e.preventDefault(), e.stopPropagation(), !o.is(".disabled, :disabled")) {
                var n = i(o),
                    a = n.hasClass("open");
                if (!a && 27 != e.which || a && 27 == e.which) return 27 == e.which && n.find(s).trigger("focus"), o.trigger("click");
                var r = " li:not(.disabled):visible a",
                    l = n.find('[role="menu"]' + r + ', [role="listbox"]' + r);
                if (l.length) {
                    var h = l.index(e.target);
                    38 == e.which && h > 0 && h--, 40 == e.which && h < l.length - 1 && h++, ~h || (h = 0), l.eq(h).trigger("focus")
                }
            }
        }
    };
    var r = t.fn.dropdown;
    t.fn.dropdown = o, t.fn.dropdown.Constructor = a, t.fn.dropdown.noConflict = function() {
        return t.fn.dropdown = r, this
    }, t(document).on("click.bs.dropdown.data-api", e).on("click.bs.dropdown.data-api", ".dropdown form", function(t) {
        t.stopPropagation()
    }).on("click.bs.dropdown.data-api", s, a.prototype.toggle).on("keydown.bs.dropdown.data-api", s, a.prototype.keydown).on("keydown.bs.dropdown.data-api", '[role="menu"]', a.prototype.keydown).on("keydown.bs.dropdown.data-api", '[role="listbox"]', a.prototype.keydown)
}(jQuery),
function(t) {
    "use strict";

    function e(e, o) {
        return this.each(function() {
            var n = t(this),
                s = n.data("bs.modal"),
                a = t.extend({}, i.DEFAULTS, n.data(), "object" == typeof e && e);
            s || n.data("bs.modal", s = new i(this, a)), "string" == typeof e ? s[e](o) : a.show && s.show(o)
        })
    }
    var i = function(e, i) {
        this.options = i, this.$body = t(document.body), this.$element = t(e), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, t.proxy(function() {
            this.$element.trigger("loaded.bs.modal")
        }, this))
    };
    i.VERSION = "3.3.2", i.TRANSITION_DURATION = 300, i.BACKDROP_TRANSITION_DURATION = 150, i.DEFAULTS = {
        backdrop: !0,
        keyboard: !0,
        show: !0
    }, i.prototype.toggle = function(t) {
        return this.isShown ? this.hide() : this.show(t)
    }, i.prototype.show = function(e) {
        var o = this,
            n = t.Event("show.bs.modal", {
                relatedTarget: e
            });
        this.$element.trigger(n), this.isShown || n.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', t.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
            o.$element.one("mouseup.dismiss.bs.modal", function(e) {
                t(e.target).is(o.$element) && (o.ignoreBackdropClick = !0)
            })
        }), this.backdrop(function() {
            var n = t.support.transition && o.$element.hasClass("fade");
            o.$element.parent().length || o.$element.appendTo(o.$body), o.$element.show().scrollTop(0), o.adjustDialog(), n && o.$element[0].offsetWidth, o.$element.addClass("in").attr("aria-hidden", !1), o.enforceFocus();
            var s = t.Event("shown.bs.modal", {
                relatedTarget: e
            });
            n ? o.$dialog.one("bsTransitionEnd", function() {
                o.$element.trigger("focus").trigger(s)
            }).emulateTransitionEnd(i.TRANSITION_DURATION) : o.$element.trigger("focus").trigger(s)
        }))
    }, i.prototype.hide = function(e) {
        e && e.preventDefault(), e = t.Event("hide.bs.modal"), this.$element.trigger(e), this.isShown && !e.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), t(document).off("focusin.bs.modal"), this.$element.removeClass("in").attr("aria-hidden", !0).off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), t.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", t.proxy(this.hideModal, this)).emulateTransitionEnd(i.TRANSITION_DURATION) : this.hideModal())
    }, i.prototype.enforceFocus = function() {
        t(document).off("focusin.bs.modal").on("focusin.bs.modal", t.proxy(function(t) {
            this.$element[0] === t.target || this.$element.has(t.target).length || this.$element.trigger("focus")
        }, this))
    }, i.prototype.escape = function() {
        this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", t.proxy(function(t) {
            27 == t.which && this.hide()
        }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal")
    }, i.prototype.resize = function() {
        this.isShown ? t(window).on("resize.bs.modal", t.proxy(this.handleUpdate, this)) : t(window).off("resize.bs.modal")
    }, i.prototype.hideModal = function() {
        var t = this;
        this.$element.hide(), this.backdrop(function() {
            t.$body.removeClass("modal-open"), t.resetAdjustments(), t.resetScrollbar(), t.$element.trigger("hidden.bs.modal")
        })
    }, i.prototype.removeBackdrop = function() {
        this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
    }, i.prototype.backdrop = function(e) {
        var o = this,
            n = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
            var s = t.support.transition && n;
            if (this.$backdrop = t('<div class="modal-backdrop ' + n + '" />').appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", t.proxy(function(t) {
                    return this.ignoreBackdropClick ? void(this.ignoreBackdropClick = !1) : void(t.target === t.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()))
                }, this)), s && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !e) return;
            s ? this.$backdrop.one("bsTransitionEnd", e).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION) : e()
        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass("in");
            var a = function() {
                o.removeBackdrop(), e && e()
            };
            t.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", a).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION) : a()
        } else e && e()
    }, i.prototype.handleUpdate = function() {
        this.adjustDialog()
    }, i.prototype.adjustDialog = function() {
        var t = this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
            paddingLeft: !this.bodyIsOverflowing && t ? this.scrollbarWidth : "",
            paddingRight: this.bodyIsOverflowing && !t ? this.scrollbarWidth : ""
        })
    }, i.prototype.resetAdjustments = function() {
        this.$element.css({
            paddingLeft: "",
            paddingRight: ""
        })
    }, i.prototype.checkScrollbar = function() {
        var t = window.innerWidth;
        if (!t) {
            var e = document.documentElement.getBoundingClientRect();
            t = e.right - Math.abs(e.left)
        }
        this.bodyIsOverflowing = document.body.clientWidth < t, this.scrollbarWidth = this.measureScrollbar()
    }, i.prototype.setScrollbar = function() {
        var t = parseInt(this.$body.css("padding-right") || 0, 10);
        this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", t + this.scrollbarWidth)
    }, i.prototype.resetScrollbar = function() {
        this.$body.css("padding-right", this.originalBodyPad)
    }, i.prototype.measureScrollbar = function() {
        var t = document.createElement("div");
        t.className = "modal-scrollbar-measure", this.$body.append(t);
        var e = t.offsetWidth - t.clientWidth;
        return this.$body[0].removeChild(t), e
    };
    var o = t.fn.modal;
    t.fn.modal = e, t.fn.modal.Constructor = i, t.fn.modal.noConflict = function() {
        return t.fn.modal = o, this
    }, t(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(i) {
        var o = t(this),
            n = o.attr("href"),
            s = t(o.attr("data-target") || n && n.replace(/.*(?=#[^\s]+$)/, "")),
            a = s.data("bs.modal") ? "toggle" : t.extend({
                remote: !/#/.test(n) && n
            }, s.data(), o.data());
        o.is("a") && i.preventDefault(), s.one("show.bs.modal", function(t) {
            t.isDefaultPrevented() || s.one("hidden.bs.modal", function() {
                o.is(":visible") && o.trigger("focus")
            })
        }), e.call(s, a, this)
    })
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        return this.each(function() {
            var o = t(this),
                n = o.data("bs.tooltip"),
                s = "object" == typeof e && e;
            (n || !/destroy|hide/.test(e)) && (n || o.data("bs.tooltip", n = new i(this, s)), "string" == typeof e && n[e]())
        })
    }
    var i = function(t, e) {
        this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.init("tooltip", t, e)
    };
    i.VERSION = "3.3.2", i.TRANSITION_DURATION = 150, i.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1,
        viewport: {
            selector: "body",
            padding: 0
        }
    }, i.prototype.init = function(e, i, o) {
        if (this.enabled = !0, this.type = e, this.$element = t(i), this.options = this.getOptions(o), this.$viewport = this.options.viewport && t(this.options.viewport.selector || this.options.viewport), this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
        for (var n = this.options.trigger.split(" "), s = n.length; s--;) {
            var a = n[s];
            if ("click" == a) this.$element.on("click." + this.type, this.options.selector, t.proxy(this.toggle, this));
            else if ("manual" != a) {
                var r = "hover" == a ? "mouseenter" : "focusin",
                    l = "hover" == a ? "mouseleave" : "focusout";
                this.$element.on(r + "." + this.type, this.options.selector, t.proxy(this.enter, this)), this.$element.on(l + "." + this.type, this.options.selector, t.proxy(this.leave, this))
            }
        }
        this.options.selector ? this._options = t.extend({}, this.options, {
            trigger: "manual",
            selector: ""
        }) : this.fixTitle()
    }, i.prototype.getDefaults = function() {
        return i.DEFAULTS
    }, i.prototype.getOptions = function(e) {
        return (e = t.extend({}, this.getDefaults(), this.$element.data(), e)).delay && "number" == typeof e.delay && (e.delay = {
            show: e.delay,
            hide: e.delay
        }), e
    }, i.prototype.getDelegateOptions = function() {
        var e = {},
            i = this.getDefaults();
        return this._options && t.each(this._options, function(t, o) {
            i[t] != o && (e[t] = o)
        }), e
    }, i.prototype.enter = function(e) {
        var i = e instanceof this.constructor ? e : t(e.currentTarget).data("bs." + this.type);
        return i && i.$tip && i.$tip.is(":visible") ? void(i.hoverState = "in") : (i || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i)), clearTimeout(i.timeout), i.hoverState = "in", i.options.delay && i.options.delay.show ? void(i.timeout = setTimeout(function() {
            "in" == i.hoverState && i.show()
        }, i.options.delay.show)) : i.show())
    }, i.prototype.leave = function(e) {
        var i = e instanceof this.constructor ? e : t(e.currentTarget).data("bs." + this.type);
        return i || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i)), clearTimeout(i.timeout), i.hoverState = "out", i.options.delay && i.options.delay.hide ? void(i.timeout = setTimeout(function() {
            "out" == i.hoverState && i.hide()
        }, i.options.delay.hide)) : i.hide()
    }, i.prototype.show = function() {
        var e = t.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
            this.$element.trigger(e);
            var o = t.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
            if (e.isDefaultPrevented() || !o) return;
            var n = this,
                s = this.tip(),
                a = this.getUID(this.type);
            this.setContent(), s.attr("id", a), this.$element.attr("aria-describedby", a), this.options.animation && s.addClass("fade");
            var r = "function" == typeof this.options.placement ? this.options.placement.call(this, s[0], this.$element[0]) : this.options.placement,
                l = /\s?auto?\s?/i,
                h = l.test(r);
            h && (r = r.replace(l, "") || "top"), s.detach().css({
                top: 0,
                left: 0,
                display: "block"
            }).addClass(r).data("bs." + this.type, this), this.options.container ? s.appendTo(this.options.container) : s.insertAfter(this.$element);
            var d = this.getPosition(),
                c = s[0].offsetWidth,
                p = s[0].offsetHeight;
            if (h) {
                var u = r,
                    f = this.options.container ? t(this.options.container) : this.$element.parent(),
                    m = this.getPosition(f);
                r = "bottom" == r && d.bottom + p > m.bottom ? "top" : "top" == r && d.top - p < m.top ? "bottom" : "right" == r && d.right + c > m.width ? "left" : "left" == r && d.left - c < m.left ? "right" : r, s.removeClass(u).addClass(r)
            }
            var g = this.getCalculatedOffset(r, d, c, p);
            this.applyPlacement(g, r);
            var w = function() {
                var t = n.hoverState;
                n.$element.trigger("shown.bs." + n.type), n.hoverState = null, "out" == t && n.leave(n)
            };
            t.support.transition && this.$tip.hasClass("fade") ? s.one("bsTransitionEnd", w).emulateTransitionEnd(i.TRANSITION_DURATION) : w()
        }
    }, i.prototype.applyPlacement = function(e, i) {
        var o = this.tip(),
            n = o[0].offsetWidth,
            s = o[0].offsetHeight,
            a = parseInt(o.css("margin-top"), 10),
            r = parseInt(o.css("margin-left"), 10);
        isNaN(a) && (a = 0), isNaN(r) && (r = 0), e.top = e.top + a, e.left = e.left + r, t.offset.setOffset(o[0], t.extend({
            using: function(t) {
                o.css({
                    top: Math.round(t.top),
                    left: Math.round(t.left)
                })
            }
        }, e), 0), o.addClass("in");
        var l = o[0].offsetWidth,
            h = o[0].offsetHeight;
        "top" == i && h != s && (e.top = e.top + s - h);
        var d = this.getViewportAdjustedDelta(i, e, l, h);
        d.left ? e.left += d.left : e.top += d.top;
        var c = /top|bottom/.test(i),
            p = c ? 2 * d.left - n + l : 2 * d.top - s + h,
            u = c ? "offsetWidth" : "offsetHeight";
        o.offset(e), this.replaceArrow(p, o[0][u], c)
    }, i.prototype.replaceArrow = function(t, e, i) {
        this.arrow().css(i ? "left" : "top", 50 * (1 - t / e) + "%").css(i ? "top" : "left", "")
    }, i.prototype.setContent = function() {
        var t = this.tip(),
            e = this.getTitle();
        t.find(".tooltip-inner")[this.options.html ? "html" : "text"](e), t.removeClass("fade in top bottom left right")
    }, i.prototype.hide = function(e) {
        function o() {
            "in" != n.hoverState && s.detach(), n.$element.removeAttr("aria-describedby").trigger("hidden.bs." + n.type), e && e()
        }
        var n = this,
            s = t(this.$tip),
            a = t.Event("hide.bs." + this.type);
        return this.$element.trigger(a), a.isDefaultPrevented() ? void 0 : (s.removeClass("in"), t.support.transition && s.hasClass("fade") ? s.one("bsTransitionEnd", o).emulateTransitionEnd(i.TRANSITION_DURATION) : o(), this.hoverState = null, this)
    }, i.prototype.fixTitle = function() {
        var t = this.$element;
        (t.attr("title") || "string" != typeof t.attr("data-original-title")) && t.attr("data-original-title", t.attr("title") || "").attr("title", "")
    }, i.prototype.hasContent = function() {
        return this.getTitle()
    }, i.prototype.getPosition = function(e) {
        var i = (e = e || this.$element)[0],
            o = "BODY" == i.tagName,
            n = i.getBoundingClientRect();
        null == n.width && (n = t.extend({}, n, {
            width: n.right - n.left,
            height: n.bottom - n.top
        }));
        var s = o ? {
                top: 0,
                left: 0
            } : e.offset(),
            a = {
                scroll: o ? document.documentElement.scrollTop || document.body.scrollTop : e.scrollTop()
            },
            r = o ? {
                width: t(window).width(),
                height: t(window).height()
            } : null;
        return t.extend({}, n, a, r, s)
    }, i.prototype.getCalculatedOffset = function(t, e, i, o) {
        return "bottom" == t ? {
            top: e.top + e.height,
            left: e.left + e.width / 2 - i / 2
        } : "top" == t ? {
            top: e.top - o,
            left: e.left + e.width / 2 - i / 2
        } : "left" == t ? {
            top: e.top + e.height / 2 - o / 2,
            left: e.left - i
        } : {
            top: e.top + e.height / 2 - o / 2,
            left: e.left + e.width
        }
    }, i.prototype.getViewportAdjustedDelta = function(t, e, i, o) {
        var n = {
            top: 0,
            left: 0
        };
        if (!this.$viewport) return n;
        var s = this.options.viewport && this.options.viewport.padding || 0,
            a = this.getPosition(this.$viewport);
        if (/right|left/.test(t)) {
            var r = e.top - s - a.scroll,
                l = e.top + s - a.scroll + o;
            r < a.top ? n.top = a.top - r : l > a.top + a.height && (n.top = a.top + a.height - l)
        } else {
            var h = e.left - s,
                d = e.left + s + i;
            h < a.left ? n.left = a.left - h : d > a.width && (n.left = a.left + a.width - d)
        }
        return n
    }, i.prototype.getTitle = function() {
        var t = this.$element,
            e = this.options;
        return t.attr("data-original-title") || ("function" == typeof e.title ? e.title.call(t[0]) : e.title)
    }, i.prototype.getUID = function(t) {
        do {
            t += ~~(1e6 * Math.random())
        } while (document.getElementById(t));
        return t
    }, i.prototype.tip = function() {
        return this.$tip = this.$tip || t(this.options.template)
    }, i.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
    }, i.prototype.enable = function() {
        this.enabled = !0
    }, i.prototype.disable = function() {
        this.enabled = !1
    }, i.prototype.toggleEnabled = function() {
        this.enabled = !this.enabled
    }, i.prototype.toggle = function(e) {
        var i = this;
        e && ((i = t(e.currentTarget).data("bs." + this.type)) || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i))), i.tip().hasClass("in") ? i.leave(i) : i.enter(i)
    }, i.prototype.destroy = function() {
        var t = this;
        clearTimeout(this.timeout), this.hide(function() {
            t.$element.off("." + t.type).removeData("bs." + t.type)
        })
    };
    var o = t.fn.tooltip;
    t.fn.tooltip = e, t.fn.tooltip.Constructor = i, t.fn.tooltip.noConflict = function() {
        return t.fn.tooltip = o, this
    }
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        return this.each(function() {
            var o = t(this),
                n = o.data("bs.popover"),
                s = "object" == typeof e && e;
            (n || !/destroy|hide/.test(e)) && (n || o.data("bs.popover", n = new i(this, s)), "string" == typeof e && n[e]())
        })
    }
    var i = function(t, e) {
        this.init("popover", t, e)
    };
    if (!t.fn.tooltip) throw new Error("Popover requires tooltip.js");
    i.VERSION = "3.3.2", i.DEFAULTS = t.extend({}, t.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    }), i.prototype = t.extend({}, t.fn.tooltip.Constructor.prototype), i.prototype.constructor = i, i.prototype.getDefaults = function() {
        return i.DEFAULTS
    }, i.prototype.setContent = function() {
        var t = this.tip(),
            e = this.getTitle(),
            i = this.getContent();
        t.find(".popover-title")[this.options.html ? "html" : "text"](e), t.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof i ? "html" : "append" : "text"](i), t.removeClass("fade top bottom left right in"), t.find(".popover-title").html() || t.find(".popover-title").hide()
    }, i.prototype.hasContent = function() {
        return this.getTitle() || this.getContent()
    }, i.prototype.getContent = function() {
        var t = this.$element,
            e = this.options;
        return t.attr("data-content") || ("function" == typeof e.content ? e.content.call(t[0]) : e.content)
    }, i.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".arrow")
    };
    var o = t.fn.popover;
    t.fn.popover = e, t.fn.popover.Constructor = i, t.fn.popover.noConflict = function() {
        return t.fn.popover = o, this
    }
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        return this.each(function() {
            var o = t(this),
                n = o.data("bs.tab");
            n || o.data("bs.tab", n = new i(this)), "string" == typeof e && n[e]()
        })
    }
    var i = function(e) {
        this.element = t(e)
    };
    i.VERSION = "3.3.2", i.TRANSITION_DURATION = 150, i.prototype.show = function() {
        var e = this.element,
            i = e.closest("ul:not(.dropdown-menu)"),
            o = e.data("target");
        if (o || (o = e.attr("href"), o = o && o.replace(/.*(?=#[^\s]*$)/, "")), !e.parent("li").hasClass("active")) {
            var n = i.find(".active:last a"),
                s = t.Event("hide.bs.tab", {
                    relatedTarget: e[0]
                }),
                a = t.Event("show.bs.tab", {
                    relatedTarget: n[0]
                });
            if (n.trigger(s), e.trigger(a), !a.isDefaultPrevented() && !s.isDefaultPrevented()) {
                var r = t(o);
                this.activate(e.closest("li"), i), this.activate(r, r.parent(), function() {
                    n.trigger({
                        type: "hidden.bs.tab",
                        relatedTarget: e[0]
                    }), e.trigger({
                        type: "shown.bs.tab",
                        relatedTarget: n[0]
                    })
                })
            }
        }
    }, i.prototype.activate = function(e, o, n) {
        function s() {
            a.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), e.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), r ? (e[0].offsetWidth, e.addClass("in")) : e.removeClass("fade"), e.parent(".dropdown-menu").length && e.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), n && n()
        }
        var a = o.find("> .active"),
            r = n && t.support.transition && (a.length && a.hasClass("fade") || !!o.find("> .fade").length);
        a.length && r ? a.one("bsTransitionEnd", s).emulateTransitionEnd(i.TRANSITION_DURATION) : s(), a.removeClass("in")
    };
    var o = t.fn.tab;
    t.fn.tab = e, t.fn.tab.Constructor = i, t.fn.tab.noConflict = function() {
        return t.fn.tab = o, this
    };
    var n = function(i) {
        i.preventDefault(), e.call(t(this), "show")
    };
    t(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', n).on("click.bs.tab.data-api", '[data-toggle="pill"]', n)
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        return this.each(function() {
            var o = t(this),
                n = o.data("bs.affix"),
                s = "object" == typeof e && e;
            n || o.data("bs.affix", n = new i(this, s)), "string" == typeof e && n[e]()
        })
    }
    var i = function(e, o) {
        this.options = t.extend({}, i.DEFAULTS, o), this.$target = t(this.options.target).on("scroll.bs.affix.data-api", t.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", t.proxy(this.checkPositionWithEventLoop, this)), this.$element = t(e), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition()
    };
    i.VERSION = "3.3.2", i.RESET = "affix affix-top affix-bottom", i.DEFAULTS = {
        offset: 0,
        target: window
    }, i.prototype.getState = function(t, e, i, o) {
        var n = this.$target.scrollTop(),
            s = this.$element.offset(),
            a = this.$target.height();
        if (null != i && "top" == this.affixed) return i > n && "top";
        if ("bottom" == this.affixed) return null != i ? !(n + this.unpin <= s.top) && "bottom" : !(t - o >= n + a) && "bottom";
        var r = null == this.affixed,
            l = r ? n : s.top,
            h = r ? a : e;
        return null != i && i >= n ? "top" : null != o && l + h >= t - o && "bottom"
    }, i.prototype.getPinnedOffset = function() {
        if (this.pinnedOffset) return this.pinnedOffset;
        this.$element.removeClass(i.RESET).addClass("affix");
        var t = this.$target.scrollTop(),
            e = this.$element.offset();
        return this.pinnedOffset = e.top - t
    }, i.prototype.checkPositionWithEventLoop = function() {
        setTimeout(t.proxy(this.checkPosition, this), 1)
    }, i.prototype.checkPosition = function() {
        if (this.$element.is(":visible")) {
            var e = this.$element.height(),
                o = this.options.offset,
                n = o.top,
                s = o.bottom,
                a = t(document.body).height();
            "object" != typeof o && (s = n = o), "function" == typeof n && (n = o.top(this.$element)), "function" == typeof s && (s = o.bottom(this.$element));
            var r = this.getState(a, e, n, s);
            if (this.affixed != r) {
                null != this.unpin && this.$element.css("top", "");
                var l = "affix" + (r ? "-" + r : ""),
                    h = t.Event(l + ".bs.affix");
                if (this.$element.trigger(h), h.isDefaultPrevented()) return;
                this.affixed = r, this.unpin = "bottom" == r ? this.getPinnedOffset() : null, this.$element.removeClass(i.RESET).addClass(l).trigger(l.replace("affix", "affixed") + ".bs.affix")
            }
            "bottom" == r && this.$element.offset({
                top: a - e - s
            })
        }
    };
    var o = t.fn.affix;
    t.fn.affix = e, t.fn.affix.Constructor = i, t.fn.affix.noConflict = function() {
        return t.fn.affix = o, this
    }, t(window).on("load", function() {
        t('[data-spy="affix"]').each(function() {
            var i = t(this),
                o = i.data();
            o.offset = o.offset || {}, null != o.offsetBottom && (o.offset.bottom = o.offsetBottom), null != o.offsetTop && (o.offset.top = o.offsetTop), e.call(i, o)
        })
    })
}(jQuery),
function(t) {
    "use strict";

    function e(e) {
        var i, o = e.attr("data-target") || (i = e.attr("href")) && i.replace(/.*(?=#[^\s]+$)/, "");
        return t(o)
    }

    function i(e) {
        return this.each(function() {
            var i = t(this),
                n = i.data("bs.collapse"),
                s = t.extend({}, o.DEFAULTS, i.data(), "object" == typeof e && e);
            !n && s.toggle && /show|hide/.test(e) && (s.toggle = !1), n || i.data("bs.collapse", n = new o(this, s)), "string" == typeof e && n[e]()
        })
    }
    var o = function(e, i) {
        this.$element = t(e), this.options = t.extend({}, o.DEFAULTS, i), this.$trigger = t('[data-toggle="collapse"][href="#' + e.id + '"],[data-toggle="collapse"][data-target="#' + e.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle()
    };
    o.VERSION = "3.3.2", o.TRANSITION_DURATION = 350, o.DEFAULTS = {
        toggle: !0
    }, o.prototype.dimension = function() {
        return this.$element.hasClass("width") ? "width" : "height"
    }, o.prototype.show = function() {
        if (!this.transitioning && !this.$element.hasClass("in")) {
            var e, n = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
            if (!(n && n.length && (e = n.data("bs.collapse")) && e.transitioning)) {
                var s = t.Event("show.bs.collapse");
                if (this.$element.trigger(s), !s.isDefaultPrevented()) {
                    n && n.length && (i.call(n, "hide"), e || n.data("bs.collapse", null));
                    var a = this.dimension();
                    this.$element.removeClass("collapse").addClass("collapsing")[a](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;
                    var r = function() {
                        this.$element.removeClass("collapsing").addClass("collapse in")[a](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
                    };
                    if (!t.support.transition) return r.call(this);
                    var l = t.camelCase(["scroll", a].join("-"));
                    this.$element.one("bsTransitionEnd", t.proxy(r, this)).emulateTransitionEnd(o.TRANSITION_DURATION)[a](this.$element[0][l])
                }
            }
        }
    }, o.prototype.hide = function() {
        if (!this.transitioning && this.$element.hasClass("in")) {
            var e = t.Event("hide.bs.collapse");
            if (this.$element.trigger(e), !e.isDefaultPrevented()) {
                var i = this.dimension();
                this.$element[i](this.$element[i]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;
                var n = function() {
                    this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
                };
                return t.support.transition ? void this.$element[i](0).one("bsTransitionEnd", t.proxy(n, this)).emulateTransitionEnd(o.TRANSITION_DURATION) : n.call(this)
            }
        }
    }, o.prototype.toggle = function() {
        this[this.$element.hasClass("in") ? "hide" : "show"]()
    }, o.prototype.getParent = function() {
        return t(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(t.proxy(function(i, o) {
            var n = t(o);
            this.addAriaAndCollapsedClass(e(n), n)
        }, this)).end()
    }, o.prototype.addAriaAndCollapsedClass = function(t, e) {
        var i = t.hasClass("in");
        t.attr("aria-expanded", i), e.toggleClass("collapsed", !i).attr("aria-expanded", i)
    };
    var n = t.fn.collapse;
    t.fn.collapse = i, t.fn.collapse.Constructor = o, t.fn.collapse.noConflict = function() {
        return t.fn.collapse = n, this
    }, t(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(o) {
        var n = t(this);
        n.attr("data-target") || o.preventDefault();
        var s = e(n),
            a = s.data("bs.collapse") ? "toggle" : n.data();
        i.call(s, a)
    })
}(jQuery),
function(t) {
    "use strict";

    function e(i, o) {
        this.$body = t(document.body), this.$scrollElement = t(t(i).is(document.body) ? window : i), this.options = t.extend({}, e.DEFAULTS, o), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", t.proxy(this.process, this)), this.refresh(), this.process()
    }

    function i(i) {
        return this.each(function() {
            var o = t(this),
                n = o.data("bs.scrollspy"),
                s = "object" == typeof i && i;
            n || o.data("bs.scrollspy", n = new e(this, s)), "string" == typeof i && n[i]()
        })
    }
    e.VERSION = "3.3.2", e.DEFAULTS = {
        offset: 10
    }, e.prototype.getScrollHeight = function() {
        return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
    }, e.prototype.refresh = function() {
        var e = this,
            i = "offset",
            o = 0;
        this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), t.isWindow(this.$scrollElement[0]) || (i = "position", o = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function() {
            var e = t(this),
                n = e.data("target") || e.attr("href"),
                s = /^#./.test(n) && t(n);
            return s && s.length && s.is(":visible") && [
                [s[i]().top + o, n]
            ] || null
        }).sort(function(t, e) {
            return t[0] - e[0]
        }).each(function() {
            e.offsets.push(this[0]), e.targets.push(this[1])
        })
    }, e.prototype.process = function() {
        var t, e = this.$scrollElement.scrollTop() + this.options.offset,
            i = this.getScrollHeight(),
            o = this.options.offset + i - this.$scrollElement.height(),
            n = this.offsets,
            s = this.targets,
            a = this.activeTarget;
        if (this.scrollHeight != i && this.refresh(), e >= o) return a != (t = s[s.length - 1]) && this.activate(t);
        if (a && e < n[0]) return this.activeTarget = null, this.clear();
        for (t = n.length; t--;) a != s[t] && e >= n[t] && (void 0 === n[t + 1] || e <= n[t + 1]) && this.activate(s[t])
    }, e.prototype.activate = function(e) {
        this.activeTarget = e, this.clear();
        var i = this.selector + '[data-target="' + e + '"],' + this.selector + '[href="' + e + '"]',
            o = t(i).parents("li").addClass("active");
        o.parent(".dropdown-menu").length && (o = o.closest("li.dropdown").addClass("active")), o.trigger("activate.bs.scrollspy")
    }, e.prototype.clear = function() {
        t(this.selector).parentsUntil(this.options.target, ".active").removeClass("active")
    };
    var o = t.fn.scrollspy;
    t.fn.scrollspy = i, t.fn.scrollspy.Constructor = e, t.fn.scrollspy.noConflict = function() {
        return t.fn.scrollspy = o, this
    }, t(window).on("load.bs.scrollspy.data-api", function() {
        t('[data-spy="scroll"]').each(function() {
            var e = t(this);
            i.call(e, e.data())
        })
    })
}(jQuery),
function(t) {
    "use strict";

    function e() {
        var t = document.createElement("bootstrap"),
            e = {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd otransitionend",
                transition: "transitionend"
            };
        for (var i in e)
            if (void 0 !== t.style[i]) return {
                end: e[i]
            };
        return !1
    }
    t.fn.emulateTransitionEnd = function(e) {
        var i = !1,
            o = this;
        t(this).one("bsTransitionEnd", function() {
            i = !0
        });
        var n = function() {
            i || t(o).trigger(t.support.transition.end)
        };
        return setTimeout(n, e), this
    }, t(function() {
        t.support.transition = e(), t.support.transition && (t.event.special.bsTransitionEnd = {
            bindType: t.support.transition.end,
            delegateType: t.support.transition.end,
            handle: function(e) {
                return t(e.target).is(this) ? e.handleObj.handler.apply(this, arguments) : void 0
            }
        })
    })
}(jQuery), jQuery.easing.jswing = jQuery.easing.swing, jQuery.extend(jQuery.easing, {
        def: "easeOutQuad",
        swing: function(t, e, i, o, n) {
            return jQuery.easing[jQuery.easing.def](t, e, i, o, n)
        },
        easeInQuad: function(t, e, i, o, n) {
            return o * (e /= n) * e + i
        },
        easeOutQuad: function(t, e, i, o, n) {
            return -o * (e /= n) * (e - 2) + i
        },
        easeInOutQuad: function(t, e, i, o, n) {
            return (e /= n / 2) < 1 ? o / 2 * e * e + i : -o / 2 * (--e * (e - 2) - 1) + i
        },
        easeInCubic: function(t, e, i, o, n) {
            return o * (e /= n) * e * e + i
        },
        easeOutCubic: function(t, e, i, o, n) {
            return o * ((e = e / n - 1) * e * e + 1) + i
        },
        easeInOutCubic: function(t, e, i, o, n) {
            return (e /= n / 2) < 1 ? o / 2 * e * e * e + i : o / 2 * ((e -= 2) * e * e + 2) + i
        },
        easeInQuart: function(t, e, i, o, n) {
            return o * (e /= n) * e * e * e + i
        },
        easeOutQuart: function(t, e, i, o, n) {
            return -o * ((e = e / n - 1) * e * e * e - 1) + i
        },
        easeInOutQuart: function(t, e, i, o, n) {
            return (e /= n / 2) < 1 ? o / 2 * e * e * e * e + i : -o / 2 * ((e -= 2) * e * e * e - 2) + i
        },
        easeInQuint: function(t, e, i, o, n) {
            return o * (e /= n) * e * e * e * e + i
        },
        easeOutQuint: function(t, e, i, o, n) {
            return o * ((e = e / n - 1) * e * e * e * e + 1) + i
        },
        easeInOutQuint: function(t, e, i, o, n) {
            return (e /= n / 2) < 1 ? o / 2 * e * e * e * e * e + i : o / 2 * ((e -= 2) * e * e * e * e + 2) + i
        },
        easeInSine: function(t, e, i, o, n) {
            return -o * Math.cos(e / n * (Math.PI / 2)) + o + i
        },
        easeOutSine: function(t, e, i, o, n) {
            return o * Math.sin(e / n * (Math.PI / 2)) + i
        },
        easeInOutSine: function(t, e, i, o, n) {
            return -o / 2 * (Math.cos(Math.PI * e / n) - 1) + i
        },
        easeInExpo: function(t, e, i, o, n) {
            return 0 == e ? i : o * Math.pow(2, 10 * (e / n - 1)) + i
        },
        easeOutExpo: function(t, e, i, o, n) {
            return e == n ? i + o : o * (1 - Math.pow(2, -10 * e / n)) + i
        },
        easeInOutExpo: function(t, e, i, o, n) {
            return 0 == e ? i : e == n ? i + o : (e /= n / 2) < 1 ? o / 2 * Math.pow(2, 10 * (e - 1)) + i : o / 2 * (2 - Math.pow(2, -10 * --e)) + i
        },
        easeInCirc: function(t, e, i, o, n) {
            return -o * (Math.sqrt(1 - (e /= n) * e) - 1) + i
        },
        easeOutCirc: function(t, e, i, o, n) {
            return o * Math.sqrt(1 - (e = e / n - 1) * e) + i
        },
        easeInOutCirc: function(t, e, i, o, n) {
            return (e /= n / 2) < 1 ? -o / 2 * (Math.sqrt(1 - e * e) - 1) + i : o / 2 * (Math.sqrt(1 - (e -= 2) * e) + 1) + i
        },
        easeInElastic: function(t, e, i, o, n) {
            var s = 1.70158,
                a = 0,
                r = o;
            if (0 == e) return i;
            if (1 == (e /= n)) return i + o;
            if (a || (a = .3 * n), r < Math.abs(o)) {
                r = o;
                s = a / 4
            } else s = a / (2 * Math.PI) * Math.asin(o / r);
            return -r * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * n - s) * (2 * Math.PI) / a) + i
        },
        easeOutElastic: function(t, e, i, o, n) {
            var s = 1.70158,
                a = 0,
                r = o;
            if (0 == e) return i;
            if (1 == (e /= n)) return i + o;
            if (a || (a = .3 * n), r < Math.abs(o)) {
                r = o;
                s = a / 4
            } else s = a / (2 * Math.PI) * Math.asin(o / r);
            return r * Math.pow(2, -10 * e) * Math.sin((e * n - s) * (2 * Math.PI) / a) + o + i
        },
        easeInOutElastic: function(t, e, i, o, n) {
            var s = 1.70158,
                a = 0,
                r = o;
            if (0 == e) return i;
            if (2 == (e /= n / 2)) return i + o;
            if (a || (a = n * (.3 * 1.5)), r < Math.abs(o)) {
                r = o;
                s = a / 4
            } else s = a / (2 * Math.PI) * Math.asin(o / r);
            return e < 1 ? r * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * n - s) * (2 * Math.PI) / a) * -.5 + i : r * Math.pow(2, -10 * (e -= 1)) * Math.sin((e * n - s) * (2 * Math.PI) / a) * .5 + o + i
        },
        easeInBack: function(t, e, i, o, n, s) {
            return void 0 == s && (s = 1.70158), o * (e /= n) * e * ((s + 1) * e - s) + i
        },
        easeOutBack: function(t, e, i, o, n, s) {
            return void 0 == s && (s = 1.70158), o * ((e = e / n - 1) * e * ((s + 1) * e + s) + 1) + i
        },
        easeInOutBack: function(t, e, i, o, n, s) {
            return void 0 == s && (s = 1.70158), (e /= n / 2) < 1 ? o / 2 * (e * e * ((1 + (s *= 1.525)) * e - s)) + i : o / 2 * ((e -= 2) * e * ((1 + (s *= 1.525)) * e + s) + 2) + i
        },
        easeInBounce: function(t, e, i, o, n) {
            return o - jQuery.easing.easeOutBounce(t, n - e, 0, o, n) + i
        },
        easeOutBounce: function(t, e, i, o, n) {
            return (e /= n) < 1 / 2.75 ? o * (7.5625 * e * e) + i : e < 2 / 2.75 ? o * (7.5625 * (e -= 1.5 / 2.75) * e + .75) + i : e < 2.5 / 2.75 ? o * (7.5625 * (e -= 2.25 / 2.75) * e + .9375) + i : o * (7.5625 * (e -= 2.625 / 2.75) * e + .984375) + i
        },
        easeInOutBounce: function(t, e, i, o, n) {
            return e < n / 2 ? .5 * jQuery.easing.easeInBounce(t, 2 * e, 0, o, n) + i : .5 * jQuery.easing.easeOutBounce(t, 2 * e - n, 0, o, n) + .5 * o + i
        }
    }),
    function(t) {
        var e = function() {
            return !1 === t.support.boxModel && t.support.objectAll && t.support.leadingWhitespace
        }();
        t.jGrowl = function(e, i) {
            0 == t("#jGrowl").size() && t('<div id="jGrowl"></div>').addClass(i && i.position ? i.position : t.jGrowl.defaults.position).appendTo("body"), t("#jGrowl").jGrowl(e, i)
        }, t.fn.jGrowl = function(e, i) {
            if (t.isFunction(this.each)) {
                var o = arguments;
                return this.each(function() {
                    void 0 == t(this).data("jGrowl.instance") && (t(this).data("jGrowl.instance", t.extend(new t.fn.jGrowl, {
                        notifications: [],
                        element: null,
                        interval: null
                    })), t(this).data("jGrowl.instance").startup(this)), t.isFunction(t(this).data("jGrowl.instance")[e]) ? t(this).data("jGrowl.instance")[e].apply(t(this).data("jGrowl.instance"), t.makeArray(o).slice(1)) : t(this).data("jGrowl.instance").create(e, i)
                })
            }
        }, t.extend(t.fn.jGrowl.prototype, {
            defaults: {
                pool: 0,
                header: "",
                group: "",
                sticky: !1,
                position: "top-right",
                glue: "after",
                theme: "default",
                themeState: "highlight",
                corners: "10px",
                check: 250,
                life: 3e3,
                closeDuration: "normal",
                openDuration: "normal",
                easing: "swing",
                closer: !0,
                closeTemplate: "<i class='fa fa-times'></i>",
                closerTemplate: "<div>[ close all ]</div>",
                log: function() {},
                beforeOpen: function() {},
                afterOpen: function() {},
                open: function() {},
                beforeClose: function() {},
                close: function() {},
                animateOpen: {
                    opacity: "show"
                },
                animateClose: {
                    opacity: "hide"
                }
            },
            notifications: [],
            element: null,
            interval: null,
            create: function(e, i) {
                void 0 !== (i = t.extend({}, this.defaults, i)).speed && (i.openDuration = i.speed, i.closeDuration = i.speed), this.notifications.push({
                    message: e,
                    options: i
                }), i.log.apply(this.element, [this.element, e, i])
            },
            render: function(e) {
                var i = this,
                    o = e.message,
                    n = e.options;
                n.themeState = "" == n.themeState ? "" : "ui-state-" + n.themeState;
                var e = t("<div/>").addClass("jGrowl-notification " + n.themeState + " ui-corner-all" + (void 0 != n.group && "" != n.group ? " " + n.group : "")).append(t("<div/>").addClass("jGrowl-close").attr("title", "Close").html(n.closeTemplate)).append(t("<div/>").addClass("jGrowl-header").html(n.header)).append(t("<div/>").addClass("jGrowl-message").html(o)).data("jGrowl", n).addClass(n.theme).children("div.jGrowl-close").bind("click.jGrowl", function() {
                    t(this).parent().trigger("jGrowl.beforeClose")
                }).parent();
                t(e).bind("mouseover.jGrowl", function() {
                    t("div.jGrowl-notification", i.element).data("jGrowl.pause", !0)
                }).bind("mouseout.jGrowl", function() {
                    t("div.jGrowl-notification", i.element).data("jGrowl.pause", !1)
                }).bind("jGrowl.beforeOpen", function() {
                    !1 !== n.beforeOpen.apply(e, [e, o, n, i.element]) && t(this).trigger("jGrowl.open")
                }).bind("jGrowl.open", function() {
                    !1 !== n.open.apply(e, [e, o, n, i.element]) && ("after" == n.glue ? t("div.jGrowl-notification:last", i.element).after(e) : t("div.jGrowl-notification:first", i.element).before(e), t(this).animate(n.animateOpen, n.openDuration, n.easing, function() {
                        !1 === t.support.opacity && this.style.removeAttribute("filter"), null !== t(this).data("jGrowl") && (t(this).data("jGrowl").created = new Date), t(this).trigger("jGrowl.afterOpen")
                    }))
                }).bind("jGrowl.afterOpen", function() {
                    n.afterOpen.apply(e, [e, o, n, i.element])
                }).bind("jGrowl.beforeClose", function() {
                    !1 !== n.beforeClose.apply(e, [e, o, n, i.element]) && t(this).trigger("jGrowl.close")
                }).bind("jGrowl.close", function() {
                    t(this).data("jGrowl.pause", !0), t(this).animate(n.animateClose, n.closeDuration, n.easing, function() {
                        t.isFunction(n.close) ? !1 !== n.close.apply(e, [e, o, n, i.element]) && t(this).remove() : t(this).remove()
                    })
                }).trigger("jGrowl.beforeOpen"), "" != n.corners && void 0 != t.fn.corner && t(e).corner(n.corners), t("div.jGrowl-notification:parent", i.element).size() > 1 && 0 == t("div.jGrowl-closer", i.element).size() && !1 !== this.defaults.closer && t(this.defaults.closerTemplate).addClass("jGrowl-closer " + this.defaults.themeState + " ui-corner-all").addClass(this.defaults.theme).appendTo(i.element).animate(this.defaults.animateOpen, this.defaults.speed, this.defaults.easing).bind("click.jGrowl", function() {
                    t(this).siblings().trigger("jGrowl.beforeClose"), t.isFunction(i.defaults.closer) && i.defaults.closer.apply(t(this).parent()[0], [t(this).parent()[0]])
                })
            },
            update: function() {
                t(this.element).find("div.jGrowl-notification:parent").each(function() {
                    void 0 != t(this).data("jGrowl") && void 0 !== t(this).data("jGrowl").created && t(this).data("jGrowl").created.getTime() + parseInt(t(this).data("jGrowl").life) < (new Date).getTime() && !0 !== t(this).data("jGrowl").sticky && (void 0 == t(this).data("jGrowl.pause") || !0 !== t(this).data("jGrowl.pause")) && t(this).trigger("jGrowl.beforeClose")
                }), this.notifications.length > 0 && (0 == this.defaults.pool || t(this.element).find("div.jGrowl-notification:parent").size() < this.defaults.pool) && this.render(this.notifications.shift()), 2 > t(this.element).find("div.jGrowl-notification:parent").size() && t(this.element).find("div.jGrowl-closer").animate(this.defaults.animateClose, this.defaults.speed, this.defaults.easing, function() {
                    t(this).remove()
                })
            },
            startup: function(i) {
                this.element = t(i).addClass("jGrowl").append('<div class="jGrowl-notification"></div>'), this.interval = setInterval(function() {
                    t(i).data("jGrowl.instance").update()
                }, parseInt(this.defaults.check)), e && t(this.element).addClass("ie6")
            },
            shutdown: function() {
                t(this.element).removeClass("jGrowl").find("div.jGrowl-notification").trigger("jGrowl.close").parent().empty(), clearInterval(this.interval)
            },
            close: function() {
                t(this.element).find("div.jGrowl-notification").each(function() {
                    t(this).trigger("jGrowl.beforeClose")
                })
            }
        }), t.jGrowl.defaults = t.fn.jGrowl.prototype.defaults
    }(jQuery),
    function(t, e, i, o) {
        "use strict";
        var n = i("html"),
            s = i(t),
            a = i(e),
            r = i.fancybox = function() {
                r.open.apply(this, arguments)
            },
            l = navigator.userAgent.match(/msie/i),
            h = null,
            d = e.createTouch !== o,
            c = function(t) {
                return t && t.hasOwnProperty && t instanceof i
            },
            p = function(t) {
                return t && "string" === i.type(t)
            },
            u = function(t) {
                return p(t) && t.indexOf("%") > 0
            },
            f = function(t) {
                return t && !(t.style.overflow && "hidden" === t.style.overflow) && (t.clientWidth && t.scrollWidth > t.clientWidth || t.clientHeight && t.scrollHeight > t.clientHeight)
            },
            m = function(t, e) {
                var i = parseInt(t, 10) || 0;
                return e && u(t) && (i = r.getViewport()[e] / 100 * i), Math.ceil(i)
            },
            g = function(t, e) {
                return m(t, e) + "px"
            };
        i.extend(r, {
            version: "2.1.5",
            defaults: {
                padding: 15,
                margin: 20,
                width: 800,
                height: 600,
                minWidth: 100,
                minHeight: 100,
                maxWidth: 9999,
                maxHeight: 9999,
                pixelRatio: 1,
                autoSize: !0,
                autoHeight: !1,
                autoWidth: !1,
                autoResize: !0,
                autoCenter: !d,
                fitToView: !0,
                aspectRatio: !1,
                topRatio: .5,
                leftRatio: .5,
                scrolling: "auto",
                wrapCSS: "",
                arrows: !0,
                closeBtn: !0,
                closeClick: !1,
                nextClick: !1,
                mouseWheel: !0,
                autoPlay: !1,
                playSpeed: 3e3,
                preload: 3,
                modal: !1,
                loop: !0,
                ajax: {
                    dataType: "html",
                    headers: {
                        "X-fancyBox": !0
                    }
                },
                iframe: {
                    scrolling: "auto",
                    preload: !0
                },
                swf: {
                    wmode: "transparent",
                    allowfullscreen: "true",
                    allowscriptaccess: "always"
                },
                keys: {
                    next: {
                        13: "left",
                        34: "up",
                        39: "left",
                        40: "up"
                    },
                    prev: {
                        8: "right",
                        33: "down",
                        37: "right",
                        38: "down"
                    },
                    close: [27],
                    play: [32],
                    toggle: [70]
                },
                direction: {
                    next: "left",
                    prev: "right"
                },
                scrollOutside: !0,
                index: 0,
                type: null,
                href: null,
                content: null,
                title: null,
                tpl: {
                    wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                    image: '<img class="fancybox-image" src="{href}" alt="" />',
                    iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (l ? ' allowtransparency="true"' : "") + "></iframe>",
                    error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                    closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                    next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                    prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
                },
                openEffect: "fade",
                openSpeed: 250,
                openEasing: "swing",
                openOpacity: !0,
                openMethod: "zoomIn",
                closeEffect: "fade",
                closeSpeed: 250,
                closeEasing: "swing",
                closeOpacity: !0,
                closeMethod: "zoomOut",
                nextEffect: "elastic",
                nextSpeed: 250,
                nextEasing: "swing",
                nextMethod: "changeIn",
                prevEffect: "elastic",
                prevSpeed: 250,
                prevEasing: "swing",
                prevMethod: "changeOut",
                helpers: {
                    overlay: !0,
                    title: !0
                },
                onCancel: i.noop,
                beforeLoad: i.noop,
                afterLoad: i.noop,
                beforeShow: i.noop,
                afterShow: i.noop,
                beforeChange: i.noop,
                beforeClose: i.noop,
                afterClose: i.noop
            },
            group: {},
            opts: {},
            previous: null,
            coming: null,
            current: null,
            isActive: !1,
            isOpen: !1,
            isOpened: !1,
            wrap: null,
            skin: null,
            outer: null,
            inner: null,
            player: {
                timer: null,
                isActive: !1
            },
            ajaxLoad: null,
            imgPreload: null,
            transitions: {},
            helpers: {},
            open: function(t, e) {
                return t && (i.isPlainObject(e) || (e = {}), !1 !== r.close(!0)) ? (i.isArray(t) || (t = c(t) ? i(t).get() : [t]), i.each(t, function(n, s) {
                    var a, l, h, d, u, f, m, g = {};
                    "object" === i.type(s) && (s.nodeType && (s = i(s)), c(s) ? (g = {
                        href: s.data("fancybox-href") || s.attr("href"),
                        title: s.data("fancybox-title") || s.attr("title"),
                        isDom: !0,
                        element: s
                    }, i.metadata && i.extend(!0, g, s.metadata())) : g = s), a = e.href || g.href || (p(s) ? s : null), l = e.title !== o ? e.title : g.title || "", !(d = (h = e.content || g.content) ? "html" : e.type || g.type) && g.isDom && ((d = s.data("fancybox-type")) || (u = s.prop("class").match(/fancybox\.(\w+)/), d = u ? u[1] : null)), p(a) && (d || (r.isImage(a) ? d = "image" : r.isSWF(a) ? d = "swf" : "#" === a.charAt(0) ? d = "inline" : p(s) && (d = "html", h = s)), "ajax" === d && (f = a.split(/\s+/, 2), a = f.shift(), m = f.shift())), h || ("inline" === d ? a ? h = i(p(a) ? a.replace(/.*(?=#[^\s]+$)/, "") : a) : g.isDom && (h = s) : "html" === d ? h = a : d || a || !g.isDom || (d = "inline", h = s)), i.extend(g, {
                        href: a,
                        type: d,
                        content: h,
                        title: l,
                        selector: m
                    }), t[n] = g
                }), r.opts = i.extend(!0, {}, r.defaults, e), e.keys !== o && (r.opts.keys = !!e.keys && i.extend({}, r.defaults.keys, e.keys)), r.group = t, r._start(r.opts.index)) : void 0
            },
            cancel: function() {
                var t = r.coming;
                t && !1 !== r.trigger("onCancel") && (r.hideLoading(), r.ajaxLoad && r.ajaxLoad.abort(), r.ajaxLoad = null, r.imgPreload && (r.imgPreload.onload = r.imgPreload.onerror = null), t.wrap && t.wrap.stop(!0, !0).trigger("onReset").remove(), r.coming = null, r.current || r._afterZoomOut(t))
            },
            close: function(t) {
                r.cancel(), !1 !== r.trigger("beforeClose") && (r.unbindEvents(), r.isActive && (r.isOpen && !0 !== t ? (r.isOpen = r.isOpened = !1, r.isClosing = !0, i(".fancybox-item, .fancybox-nav").remove(), r.wrap.stop(!0, !0).removeClass("fancybox-opened"), r.transitions[r.current.closeMethod]()) : (i(".fancybox-wrap").stop(!0).trigger("onReset").remove(), r._afterZoomOut())))
            },
            play: function(t) {
                var e = function() {
                        clearTimeout(r.player.timer)
                    },
                    i = function() {
                        e(), r.current && r.player.isActive && (r.player.timer = setTimeout(r.next, r.current.playSpeed))
                    },
                    o = function() {
                        e(), a.unbind(".player"), r.player.isActive = !1, r.trigger("onPlayEnd")
                    };
                !0 === t || !r.player.isActive && !1 !== t ? function() {
                    r.current && (r.current.loop || r.current.index < r.group.length - 1) && (r.player.isActive = !0, a.bind({
                        "onCancel.player beforeClose.player": o,
                        "onUpdate.player": i,
                        "beforeLoad.player": e
                    }), i(), r.trigger("onPlayStart"))
                }() : o()
            },
            next: function(t) {
                var e = r.current;
                e && (p(t) || (t = e.direction.next), r.jumpto(e.index + 1, t, "next"))
            },
            prev: function(t) {
                var e = r.current;
                e && (p(t) || (t = e.direction.prev), r.jumpto(e.index - 1, t, "prev"))
            },
            jumpto: function(t, e, i) {
                var n = r.current;
                n && (t = m(t), r.direction = e || n.direction[t >= n.index ? "next" : "prev"], r.router = i || "jumpto", n.loop && (0 > t && (t = n.group.length + t % n.group.length), t %= n.group.length), n.group[t] !== o && (r.cancel(), r._start(t)))
            },
            reposition: function(t, e) {
                var o, n = r.current,
                    s = n ? n.wrap : null;
                s && (o = r._getPosition(e), t && "scroll" === t.type ? (delete o.position, s.stop(!0, !0).animate(o, 200)) : (s.css(o), n.pos = i.extend({}, n.dim, o)))
            },
            update: function(t) {
                var e = t && t.type,
                    i = !e || "orientationchange" === e;
                i && (clearTimeout(h), h = null), r.isOpen && !h && (h = setTimeout(function() {
                    var o = r.current;
                    o && !r.isClosing && (r.wrap.removeClass("fancybox-tmp"), (i || "load" === e || "resize" === e && o.autoResize) && r._setDimension(), "scroll" === e && o.canShrink || r.reposition(t), r.trigger("onUpdate"), h = null)
                }, i && !d ? 0 : 300))
            },
            toggle: function(t) {
                r.isOpen && (r.current.fitToView = "boolean" === i.type(t) ? t : !r.current.fitToView, d && (r.wrap.removeAttr("style").addClass("fancybox-tmp"), r.trigger("onUpdate")), r.update())
            },
            hideLoading: function() {
                a.unbind(".loading"), i("#fancybox-loading").remove()
            },
            showLoading: function() {
                var t, e;
                r.hideLoading(), t = i('<div id="fancybox-loading"><div></div></div>').click(r.cancel).appendTo("body"), a.bind("keydown.loading", function(t) {
                    27 === (t.which || t.keyCode) && (t.preventDefault(), r.cancel())
                }), r.defaults.fixed || (e = r.getViewport(), t.css({
                    position: "absolute",
                    top: .5 * e.h + e.y,
                    left: .5 * e.w + e.x
                }))
            },
            getViewport: function() {
                var e = r.current && r.current.locked || !1,
                    i = {
                        x: s.scrollLeft(),
                        y: s.scrollTop()
                    };
                return e ? (i.w = e[0].clientWidth, i.h = e[0].clientHeight) : (i.w = d && t.innerWidth ? t.innerWidth : s.width(), i.h = d && t.innerHeight ? t.innerHeight : s.height()), i
            },
            unbindEvents: function() {
                r.wrap && c(r.wrap) && r.wrap.unbind(".fb"), a.unbind(".fb"), s.unbind(".fb")
            },
            bindEvents: function() {
                var t, e = r.current;
                e && (s.bind("orientationchange.fb" + (d ? "" : " resize.fb") + (e.autoCenter && !e.locked ? " scroll.fb" : ""), r.update), (t = e.keys) && a.bind("keydown.fb", function(n) {
                    var s = n.which || n.keyCode,
                        a = n.target || n.srcElement;
                    return (27 !== s || !r.coming) && void(n.ctrlKey || n.altKey || n.shiftKey || n.metaKey || a && (a.type || i(a).is("[contenteditable]")) || i.each(t, function(t, a) {
                        return e.group.length > 1 && a[s] !== o ? (r[t](a[s]), n.preventDefault(), !1) : i.inArray(s, a) > -1 ? (r[t](), n.preventDefault(), !1) : void 0
                    }))
                }), i.fn.mousewheel && e.mouseWheel && r.wrap.bind("mousewheel.fb", function(t, o, n, s) {
                    for (var a = t.target || null, l = i(a), h = !1; l.length && !(h || l.is(".fancybox-skin") || l.is(".fancybox-wrap"));) h = f(l[0]), l = i(l).parent();
                    0 === o || h || r.group.length > 1 && !e.canShrink && (s > 0 || n > 0 ? r.prev(s > 0 ? "down" : "left") : (0 > s || 0 > n) && r.next(0 > s ? "up" : "right"), t.preventDefault())
                }))
            },
            trigger: function(t, e) {
                var o, n = e || r.coming || r.current;
                if (n) {
                    if (i.isFunction(n[t]) && (o = n[t].apply(n, Array.prototype.slice.call(arguments, 1))), !1 === o) return !1;
                    n.helpers && i.each(n.helpers, function(e, o) {
                        o && r.helpers[e] && i.isFunction(r.helpers[e][t]) && r.helpers[e][t](i.extend(!0, {}, r.helpers[e].defaults, o), n)
                    }), a.trigger(t)
                }
            },
            isImage: function(t) {
                return p(t) && t.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)
            },
            isSWF: function(t) {
                return p(t) && t.match(/\.(swf)((\?|#).*)?$/i)
            },
            _start: function(t) {
                var e, o, n, s, a, l = {};
                if (t = m(t), !(e = r.group[t] || null)) return !1;
                if (l = i.extend(!0, {}, r.opts, e), s = l.margin, a = l.padding, "number" === i.type(s) && (l.margin = [s, s, s, s]), "number" === i.type(a) && (l.padding = [a, a, a, a]), l.modal && i.extend(!0, l, {
                        closeBtn: !1,
                        closeClick: !1,
                        nextClick: !1,
                        arrows: !1,
                        mouseWheel: !1,
                        keys: null,
                        helpers: {
                            overlay: {
                                closeClick: !1
                            }
                        }
                    }), l.autoSize && (l.autoWidth = l.autoHeight = !0), "auto" === l.width && (l.autoWidth = !0), "auto" === l.height && (l.autoHeight = !0), l.group = r.group, l.index = t, r.coming = l, !1 !== r.trigger("beforeLoad")) {
                    if (n = l.type, o = l.href, !n) return r.coming = null, !(!r.current || !r.router || "jumpto" === r.router) && (r.current.index = t, r[r.router](r.direction));
                    if (r.isActive = !0, ("image" === n || "swf" === n) && (l.autoHeight = l.autoWidth = !1, l.scrolling = "visible"), "image" === n && (l.aspectRatio = !0), "iframe" === n && d && (l.scrolling = "scroll"), l.wrap = i(l.tpl.wrap).addClass("fancybox-" + (d ? "mobile" : "desktop") + " fancybox-type-" + n + " fancybox-tmp " + l.wrapCSS).appendTo(l.parent || "body"), i.extend(l, {
                            skin: i(".fancybox-skin", l.wrap),
                            outer: i(".fancybox-outer", l.wrap),
                            inner: i(".fancybox-inner", l.wrap)
                        }), i.each(["Top", "Right", "Bottom", "Left"], function(t, e) {
                            l.skin.css("padding" + e, g(l.padding[t]))
                        }), r.trigger("onReady"), "inline" === n || "html" === n) {
                        if (!l.content || !l.content.length) return r._error("content")
                    } else if (!o) return r._error("href");
                    "image" === n ? r._loadImage() : "ajax" === n ? r._loadAjax() : "iframe" === n ? r._loadIframe() : r._afterLoad()
                } else r.coming = null
            },
            _error: function(t) {
                i.extend(r.coming, {
                    type: "html",
                    autoWidth: !0,
                    autoHeight: !0,
                    minWidth: 0,
                    minHeight: 0,
                    scrolling: "no",
                    hasError: t,
                    content: r.coming.tpl.error
                }), r._afterLoad()
            },
            _loadImage: function() {
                var t = r.imgPreload = new Image;
                t.onload = function() {
                    this.onload = this.onerror = null, r.coming.width = this.width / r.opts.pixelRatio, r.coming.height = this.height / r.opts.pixelRatio, r._afterLoad()
                }, t.onerror = function() {
                    this.onload = this.onerror = null, r._error("image")
                }, t.src = r.coming.href, !0 !== t.complete && r.showLoading()
            },
            _loadAjax: function() {
                var t = r.coming;
                r.showLoading(), r.ajaxLoad = i.ajax(i.extend({}, t.ajax, {
                    url: t.href,
                    error: function(t, e) {
                        r.coming && "abort" !== e ? r._error("ajax", t) : r.hideLoading()
                    },
                    success: function(e, i) {
                        "success" === i && (t.content = e, r._afterLoad())
                    }
                }))
            },
            _loadIframe: function() {
                var t = r.coming,
                    e = i(t.tpl.iframe.replace(/\{rnd\}/g, (new Date).getTime())).attr("scrolling", d ? "auto" : t.iframe.scrolling).attr("src", t.href);
                i(t.wrap).bind("onReset", function() {
                    try {
                        i(this).find("iframe").hide().attr("src", "//about:blank").end().empty()
                    } catch (t) {}
                }), t.iframe.preload && (r.showLoading(), e.one("load", function() {
                    i(this).data("ready", 1), d || i(this).bind("load.fb", r.update), i(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show(), r._afterLoad()
                })), t.content = e.appendTo(t.inner), t.iframe.preload || r._afterLoad()
            },
            _preloadImages: function() {
                var t, e, i = r.group,
                    o = r.current,
                    n = i.length,
                    s = o.preload ? Math.min(o.preload, n - 1) : 0;
                for (e = 1; s >= e; e += 1) "image" === (t = i[(o.index + e) % n]).type && t.href && ((new Image).src = t.href)
            },
            _afterLoad: function() {
                var t, e, o, n, s, a, l = r.coming,
                    h = r.current,
                    d = "fancybox-placeholder";
                if (r.hideLoading(), l && !1 !== r.isActive) {
                    if (!1 === r.trigger("afterLoad", l, h)) return l.wrap.stop(!0).trigger("onReset").remove(), void(r.coming = null);
                    switch (h && (r.trigger("beforeChange", h), h.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove()), r.unbindEvents(), t = l, e = l.content, o = l.type, n = l.scrolling, i.extend(r, {
                            wrap: t.wrap,
                            skin: t.skin,
                            outer: t.outer,
                            inner: t.inner,
                            current: t,
                            previous: h
                        }), s = t.href, o) {
                        case "inline":
                        case "ajax":
                        case "html":
                            t.selector ? e = i("<div>").html(e).find(t.selector) : c(e) && (e.data(d) || e.data(d, i('<div class="' + d + '"></div>').insertAfter(e).hide()), e = e.show().detach(), t.wrap.bind("onReset", function() {
                                i(this).find(e).length && e.hide().replaceAll(e.data(d)).data(d, !1)
                            }));
                            break;
                        case "image":
                            e = t.tpl.image.replace("{href}", s);
                            break;
                        case "swf":
                            e = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + s + '"></param>', a = "", i.each(t.swf, function(t, i) {
                                e += '<param name="' + t + '" value="' + i + '"></param>', a += " " + t + '="' + i + '"'
                            }), e += '<embed src="' + s + '" type="application/x-shockwave-flash" width="100%" height="100%"' + a + "></embed></object>"
                    }
                    c(e) && e.parent().is(t.inner) || t.inner.append(e), r.trigger("beforeShow"), t.inner.css("overflow", "yes" === n ? "scroll" : "no" === n ? "hidden" : n), r._setDimension(), r.reposition(), r.isOpen = !1, r.coming = null, r.bindEvents(), r.isOpened ? h.prevMethod && r.transitions[h.prevMethod]() : i(".fancybox-wrap").not(t.wrap).stop(!0).trigger("onReset").remove(), r.transitions[r.isOpened ? t.nextMethod : t.openMethod](), r._preloadImages()
                }
            },
            _setDimension: function() {
                var t, e, o, n, s, a, l, h, d, c, p, f, w, v, y, b = r.getViewport(),
                    z = 0,
                    x = !1,
                    C = !1,
                    S = r.wrap,
                    T = r.skin,
                    j = r.inner,
                    W = r.current,
                    k = W.width,
                    $ = W.height,
                    O = W.minWidth,
                    L = W.minHeight,
                    I = W.maxWidth,
                    E = W.maxHeight,
                    Q = W.scrolling,
                    P = W.scrollOutside ? W.scrollbarWidth : 0,
                    H = W.margin,
                    A = m(H[1] + H[3]),
                    D = m(H[0] + H[2]);
                if (S.add(T).add(j).width("auto").height("auto").removeClass("fancybox-tmp"), t = m(T.outerWidth(!0) - T.width()), e = m(T.outerHeight(!0) - T.height()), o = A + t, n = D + e, s = u(k) ? (b.w - o) * m(k) / 100 : k, a = u($) ? (b.h - n) * m($) / 100 : $, "iframe" === W.type) {
                    if (v = W.content, W.autoHeight && 1 === v.data("ready")) try {
                        v[0].contentWindow.document.location && (j.width(s).height(9999), y = v.contents().find("body"), P && y.css("overflow-x", "hidden"), a = y.outerHeight(!0))
                    } catch (t) {}
                } else(W.autoWidth || W.autoHeight) && (j.addClass("fancybox-tmp"), W.autoWidth || j.width(s), W.autoHeight || j.height(a), W.autoWidth && (s = j.width()), W.autoHeight && (a = j.height()), j.removeClass("fancybox-tmp"));
                if (k = m(s), $ = m(a), d = s / a, O = m(u(O) ? m(O, "w") - o : O), I = m(u(I) ? m(I, "w") - o : I), L = m(u(L) ? m(L, "h") - n : L), E = m(u(E) ? m(E, "h") - n : E), l = I, h = E, W.fitToView && (I = Math.min(b.w - o, I), E = Math.min(b.h - n, E)), f = b.w - A, w = b.h - D, W.aspectRatio ? (k > I && (k = I, $ = m(k / d)), $ > E && ($ = E, k = m($ * d)), O > k && (k = O, $ = m(k / d)), L > $ && ($ = L, k = m($ * d))) : (k = Math.max(O, Math.min(k, I)), W.autoHeight && "iframe" !== W.type && (j.width(k), $ = j.height()), $ = Math.max(L, Math.min($, E))), W.fitToView)
                    if (j.width(k).height($), S.width(k + t), c = S.width(), p = S.height(), W.aspectRatio)
                        for (;
                            (c > f || p > w) && k > O && $ > L && !(z++ > 19);) $ = Math.max(L, Math.min(E, $ - 10)), k = m($ * d), O > k && (k = O, $ = m(k / d)), k > I && (k = I, $ = m(k / d)), j.width(k).height($), S.width(k + t), c = S.width(), p = S.height();
                    else k = Math.max(O, Math.min(k, k - (c - f))), $ = Math.max(L, Math.min($, $ - (p - w)));
                P && "auto" === Q && a > $ && f > k + t + P && (k += P), j.width(k).height($), S.width(k + t), c = S.width(), p = S.height(), x = (c > f || p > w) && k > O && $ > L, C = W.aspectRatio ? l > k && h > $ && s > k && a > $ : (l > k || h > $) && (s > k || a > $), i.extend(W, {
                    dim: {
                        width: g(c),
                        height: g(p)
                    },
                    origWidth: s,
                    origHeight: a,
                    canShrink: x,
                    canExpand: C,
                    wPadding: t,
                    hPadding: e,
                    wrapSpace: p - T.outerHeight(!0),
                    skinSpace: T.height() - $
                }), !v && W.autoHeight && $ > L && E > $ && !C && j.height("auto")
            },
            _getPosition: function(t) {
                var e = r.current,
                    i = r.getViewport(),
                    o = e.margin,
                    n = r.wrap.width() + o[1] + o[3],
                    s = r.wrap.height() + o[0] + o[2],
                    a = {
                        position: "absolute",
                        top: o[0],
                        left: o[3]
                    };
                return e.autoCenter && e.fixed && !t && s <= i.h && n <= i.w ? a.position = "fixed" : e.locked || (a.top += i.y, a.left += i.x), a.top = g(Math.max(a.top, a.top + (i.h - s) * e.topRatio)), a.left = g(Math.max(a.left, a.left + (i.w - n) * e.leftRatio)), a
            },
            _afterZoomIn: function() {
                var t = r.current;
                t && (r.isOpen = r.isOpened = !0, r.wrap.css("overflow", "visible").addClass("fancybox-opened"), r.update(), (t.closeClick || t.nextClick && r.group.length > 1) && r.inner.css("cursor", "pointer").bind("click.fb", function(e) {
                    i(e.target).is("a") || i(e.target).parent().is("a") || (e.preventDefault(), r[t.closeClick ? "close" : "next"]())
                }), t.closeBtn && i(t.tpl.closeBtn).appendTo(r.skin).bind("click.fb", function(t) {
                    t.preventDefault(), r.close()
                }), t.arrows && r.group.length > 1 && ((t.loop || t.index > 0) && i(t.tpl.prev).appendTo(r.outer).bind("click.fb", r.prev), (t.loop || t.index < r.group.length - 1) && i(t.tpl.next).appendTo(r.outer).bind("click.fb", r.next)), r.trigger("afterShow"), t.loop || t.index !== t.group.length - 1 ? r.opts.autoPlay && !r.player.isActive && (r.opts.autoPlay = !1, r.play()) : r.play(!1))
            },
            _afterZoomOut: function(t) {
                t = t || r.current, i(".fancybox-wrap").trigger("onReset").remove(), i.extend(r, {
                    group: {},
                    opts: {},
                    router: !1,
                    current: null,
                    isActive: !1,
                    isOpened: !1,
                    isOpen: !1,
                    isClosing: !1,
                    wrap: null,
                    skin: null,
                    outer: null,
                    inner: null
                }), r.trigger("afterClose", t)
            }
        }), r.transitions = {
            getOrigPosition: function() {
                var t = r.current,
                    e = t.element,
                    i = t.orig,
                    o = {},
                    n = 50,
                    s = 50,
                    a = t.hPadding,
                    l = t.wPadding,
                    h = r.getViewport();
                return !i && t.isDom && e.is(":visible") && ((i = e.find("img:first")).length || (i = e)), c(i) ? (o = i.offset(), i.is("img") && (n = i.outerWidth(), s = i.outerHeight())) : (o.top = h.y + (h.h - s) * t.topRatio, o.left = h.x + (h.w - n) * t.leftRatio), ("fixed" === r.wrap.css("position") || t.locked) && (o.top -= h.y, o.left -= h.x), o = {
                    top: g(o.top - a * t.topRatio),
                    left: g(o.left - l * t.leftRatio),
                    width: g(n + l),
                    height: g(s + a)
                }
            },
            step: function(t, e) {
                var i, o, n, s = e.prop,
                    a = r.current,
                    l = a.wrapSpace,
                    h = a.skinSpace;
                ("width" === s || "height" === s) && (i = e.end === e.start ? 1 : (t - e.start) / (e.end - e.start), r.isClosing && (i = 1 - i), o = "width" === s ? a.wPadding : a.hPadding, n = t - o, r.skin[s](m("width" === s ? n : n - l * i)), r.inner[s](m("width" === s ? n : n - l * i - h * i)))
            },
            zoomIn: function() {
                var t = r.current,
                    e = t.pos,
                    o = t.openEffect,
                    n = "elastic" === o,
                    s = i.extend({
                        opacity: 1
                    }, e);
                delete s.position, n ? (e = this.getOrigPosition(), t.openOpacity && (e.opacity = .1)) : "fade" === o && (e.opacity = .1), r.wrap.css(e).animate(s, {
                    duration: "none" === o ? 0 : t.openSpeed,
                    easing: t.openEasing,
                    step: n ? this.step : null,
                    complete: r._afterZoomIn
                })
            },
            zoomOut: function() {
                var t = r.current,
                    e = t.closeEffect,
                    i = "elastic" === e,
                    o = {
                        opacity: .1
                    };
                i && (o = this.getOrigPosition(), t.closeOpacity && (o.opacity = .1)), r.wrap.animate(o, {
                    duration: "none" === e ? 0 : t.closeSpeed,
                    easing: t.closeEasing,
                    step: i ? this.step : null,
                    complete: r._afterZoomOut
                })
            },
            changeIn: function() {
                var t, e = r.current,
                    i = e.nextEffect,
                    o = e.pos,
                    n = {
                        opacity: 1
                    },
                    s = r.direction,
                    a = 200;
                o.opacity = .1, "elastic" === i && (t = "down" === s || "up" === s ? "top" : "left", "down" === s || "right" === s ? (o[t] = g(m(o[t]) - a), n[t] = "+=200px") : (o[t] = g(m(o[t]) + a), n[t] = "-=200px")), "none" === i ? r._afterZoomIn() : r.wrap.css(o).animate(n, {
                    duration: e.nextSpeed,
                    easing: e.nextEasing,
                    complete: r._afterZoomIn
                })
            },
            changeOut: function() {
                var t = r.previous,
                    e = t.prevEffect,
                    o = {
                        opacity: .1
                    },
                    n = r.direction;
                "elastic" === e && (o["down" === n || "up" === n ? "top" : "left"] = ("up" === n || "left" === n ? "-" : "+") + "=200px"), t.wrap.animate(o, {
                    duration: "none" === e ? 0 : t.prevSpeed,
                    easing: t.prevEasing,
                    complete: function() {
                        i(this).trigger("onReset").remove()
                    }
                })
            }
        }, r.helpers.overlay = {
            defaults: {
                closeClick: !0,
                speedOut: 200,
                showEarly: !0,
                css: {},
                locked: !d,
                fixed: !0
            },
            overlay: null,
            fixed: !1,
            el: i("html"),
            create: function(t) {
                t = i.extend({}, this.defaults, t), this.overlay && this.close(), this.overlay = i('<div class="fancybox-overlay"></div>').appendTo(r.coming ? r.coming.parent : t.parent), this.fixed = !1, t.fixed && r.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"), this.fixed = !0)
            },
            open: function(t) {
                var e = this;
                t = i.extend({}, this.defaults, t), this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(t), this.fixed || (s.bind("resize.overlay", i.proxy(this.update, this)), this.update()), t.closeClick && this.overlay.bind("click.overlay", function(t) {
                    return i(t.target).hasClass("fancybox-overlay") ? (r.isActive ? r.close() : e.close(), !1) : void 0
                }), this.overlay.css(t.css).show()
            },
            close: function() {
                var t, e;
                s.unbind("resize.overlay"), this.el.hasClass("fancybox-lock") && (i(".fancybox-margin").removeClass("fancybox-margin"), t = s.scrollTop(), e = s.scrollLeft(), this.el.removeClass("fancybox-lock"), s.scrollTop(t).scrollLeft(e)), i(".fancybox-overlay").remove().hide(), i.extend(this, {
                    overlay: null,
                    fixed: !1
                })
            },
            update: function() {
                var t, i = "100%";
                this.overlay.width(i).height("100%"), l ? (t = Math.max(e.documentElement.offsetWidth, e.body.offsetWidth), a.width() > t && (i = a.width())) : a.width() > s.width() && (i = a.width()), this.overlay.width(i).height(a.height())
            },
            onReady: function(t, e) {
                var o = this.overlay;
                i(".fancybox-overlay").stop(!0, !0), o || this.create(t), t.locked && this.fixed && e.fixed && (o || (this.margin = a.height() > s.height() && i("html").css("margin-right").replace("px", "")), e.locked = this.overlay.append(e.wrap), e.fixed = !1), !0 === t.showEarly && this.beforeShow.apply(this, arguments)
            },
            beforeShow: function(t, e) {
                var o, n;
                e.locked && (!1 !== this.margin && (i("*").filter(function() {
                    return "fixed" === i(this).css("position") && !i(this).hasClass("fancybox-overlay") && !i(this).hasClass("fancybox-wrap")
                }).addClass("fancybox-margin"), this.el.addClass("fancybox-margin")), o = s.scrollTop(), n = s.scrollLeft(), this.el.addClass("fancybox-lock"), s.scrollTop(o).scrollLeft(n)), this.open(t)
            },
            onUpdate: function() {
                this.fixed || this.update()
            },
            afterClose: function(t) {
                this.overlay && !r.coming && this.overlay.fadeOut(t.speedOut, i.proxy(this.close, this))
            }
        }, r.helpers.title = {
            defaults: {
                type: "float",
                position: "bottom"
            },
            beforeShow: function(t) {
                var e, o, n = r.current,
                    s = n.title,
                    a = t.type;
                if (i.isFunction(s) && (s = s.call(n.element, n)), p(s) && "" !== i.trim(s)) {
                    switch (e = i('<div class="fancybox-title fancybox-title-' + a + '-wrap">' + s + "</div>"), a) {
                        case "inside":
                            o = r.skin;
                            break;
                        case "outside":
                            o = r.wrap;
                            break;
                        case "over":
                            o = r.inner;
                            break;
                        default:
                            o = r.skin, e.appendTo("body"), l && e.width(e.width()), e.wrapInner('<span class="child"></span>'), r.current.margin[2] += Math.abs(m(e.css("margin-bottom")))
                    }
                    e["top" === t.position ? "prependTo" : "appendTo"](o)
                }
            }
        }, i.fn.fancybox = function(t) {
            var e, o = i(this),
                n = this.selector || "",
                s = function(s) {
                    var a, l, h = i(this).blur(),
                        d = e;
                    s.ctrlKey || s.altKey || s.shiftKey || s.metaKey || h.is(".fancybox-wrap") || (a = t.groupAttr || "data-fancybox-group", (l = h.attr(a)) || (a = "rel", l = h.get(0)[a]), l && "" !== l && "nofollow" !== l && (h = n.length ? i(n) : o, h = h.filter("[" + a + '="' + l + '"]'), d = h.index(this)), t.index = d, !1 !== r.open(h, t) && s.preventDefault())
                };
            return t = t || {}, e = t.index || 0, n && !1 !== t.live ? a.undelegate(n, "click.fb-start").delegate(n + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", s) : o.unbind("click.fb-start").bind("click.fb-start", s), this.filter("[data-fancybox-start=1]").trigger("click"), this
        }, a.ready(function() {
            var e, s;
            i.scrollbarWidth === o && (i.scrollbarWidth = function() {
                var t = i('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
                    e = t.children(),
                    o = e.innerWidth() - e.height(99).innerWidth();
                return t.remove(), o
            }), i.support.fixedPosition === o && (i.support.fixedPosition = function() {
                var t = i('<div style="position:fixed;top:20px;"></div>').appendTo("body"),
                    e = 20 === t[0].offsetTop || 15 === t[0].offsetTop;
                return t.remove(), e
            }()), i.extend(r.defaults, {
                scrollbarWidth: i.scrollbarWidth(),
                fixed: i.support.fixedPosition,
                parent: i("body")
            }), e = i(t).width(), n.addClass("fancybox-lock-test"), s = i(t).width(), n.removeClass("fancybox-lock-test"), i("<style type='text/css'>.fancybox-margin{margin-right:" + (s - e) + "px;}</style>").appendTo("head")
        })
    }(window, document, jQuery),
    function(t) {
        var e = t.fancybox;
        e.helpers.buttons = {
            defaults: {
                skipSingle: !1,
                position: "top",
                tpl: '<div id="fancybox-buttons"><ul><li><a class="btnPrev" title="Previous" href="javascript:;"></a></li><li><a class="btnPlay" title="Start slideshow" href="javascript:;"></a></li><li><a class="btnNext" title="Next" href="javascript:;"></a></li><li><a class="btnToggle" title="Toggle size" href="javascript:;"></a></li><li><a class="btnClose" title="Close" href="javascript:;"></a></li></ul></div>'
            },
            list: null,
            buttons: null,
            beforeLoad: function(t, e) {
                return t.skipSingle && e.group.length < 2 ? (e.helpers.buttons = !1, void(e.closeBtn = !0)) : void(e.margin["bottom" === t.position ? 2 : 0] += 30)
            },
            onPlayStart: function() {
                this.buttons && this.buttons.play.attr("title", "Pause slideshow").addClass("btnPlayOn")
            },
            onPlayEnd: function() {
                this.buttons && this.buttons.play.attr("title", "Start slideshow").removeClass("btnPlayOn")
            },
            afterShow: function(i, o) {
                var n = this.buttons;
                n || (this.list = t(i.tpl).addClass(i.position).appendTo("body"), n = {
                    prev: this.list.find(".btnPrev").click(e.prev),
                    next: this.list.find(".btnNext").click(e.next),
                    play: this.list.find(".btnPlay").click(e.play),
                    toggle: this.list.find(".btnToggle").click(e.toggle),
                    close: this.list.find(".btnClose").click(e.close)
                }), o.index > 0 || o.loop ? n.prev.removeClass("btnDisabled") : n.prev.addClass("btnDisabled"), o.loop || o.index < o.group.length - 1 ? (n.next.removeClass("btnDisabled"), n.play.removeClass("btnDisabled")) : (n.next.addClass("btnDisabled"), n.play.addClass("btnDisabled")), this.buttons = n, this.onUpdate(i, o)
            },
            onUpdate: function(t, e) {
                var i;
                this.buttons && (i = this.buttons.toggle.removeClass("btnDisabled btnToggleOn"), e.canShrink ? i.addClass("btnToggleOn") : e.canExpand || i.addClass("btnDisabled"))
            },
            beforeClose: function() {
                this.list && this.list.remove(), this.list = null, this.buttons = null
            }
        }
    }(jQuery), "function" != typeof Object.create && (Object.create = function(t) {
        function e() {}
        return e.prototype = t, new e
    }),
    function(t, e, i, o) {
        var n = {
            init: function(e, i) {
                var o = this;
                o.elem = i, o.$elem = t(i), o.imageSrc = o.$elem.data("zoom-image") ? o.$elem.data("zoom-image") : o.$elem.attr("src"), o.options = t.extend({}, t.fn.elevateZoom.options, e), o.options.tint && (o.options.lensColour = "none", o.options.lensOpacity = "1"), "inner" == o.options.zoomType && (o.options.showLens = !1), o.$elem.parent().removeAttr("title").removeAttr("alt"), o.zoomImage = o.imageSrc, o.refresh(1), t("#" + o.options.gallery + " a").click(function(e) {
                    return o.options.galleryActiveClass && (t("#" + o.options.gallery + " a").removeClass(o.options.galleryActiveClass), t(this).addClass(o.options.galleryActiveClass)), e.preventDefault(), t(this).data("zoom-image") ? o.zoomImagePre = t(this).data("zoom-image") : o.zoomImagePre = t(this).data("image"), o.swaptheimage(t(this).data("image"), o.zoomImagePre), !1
                })
            },
            refresh: function(t) {
                var e = this;
                setTimeout(function() {
                    e.fetch(e.imageSrc)
                }, t || e.options.refresh)
            },
            fetch: function(t) {
                var e = this,
                    i = new Image;
                i.onload = function() {
                    e.largeWidth = i.width, e.largeHeight = i.height, e.startZoom(), e.currentImage = e.imageSrc, e.options.onZoomedImageLoaded(e.$elem)
                }, i.src = t
            },
            startZoom: function() {
                var e = this;
                e.nzWidth = e.$elem.width(), e.nzHeight = e.$elem.height(), e.isWindowActive = !1, e.isLensActive = !1, e.isTintActive = !1, e.overWindow = !1, e.options.imageCrossfade && (e.zoomWrap = e.$elem.wrap('<div style="height:' + e.nzHeight + "px;width:" + e.nzWidth + 'px;" class="zoomWrapper" />'), e.$elem.css("position", "absolute")), e.zoomLock = 1, e.scrollingLock = !1, e.changeBgSize = !1, e.currentZoomLevel = e.options.zoomLevel, e.nzOffset = e.$elem.offset(), e.widthRatio = e.largeWidth / e.currentZoomLevel / e.nzWidth, e.heightRatio = e.largeHeight / e.currentZoomLevel / e.nzHeight, "window" == e.options.zoomType && (e.zoomWindowStyle = "overflow: hidden;background-position: 0px 0px;text-align:center;background-color: " + String(e.options.zoomWindowBgColour) + ";width: " + String(e.options.zoomWindowWidth) + "px;height: " + String(e.options.zoomWindowHeight) + "px;float: left;background-size: " + e.largeWidth / e.currentZoomLevel + "px " + e.largeHeight / e.currentZoomLevel + "px;display: none;z-index:100px;border: " + String(e.options.borderSize) + "px solid " + e.options.borderColour + ";background-repeat: no-repeat;position: absolute;"), "inner" == e.options.zoomType && (e.zoomWindowStyle = "overflow: hidden;background-position: 0px 0px;width: " + String(e.nzWidth) + "px;height: " + String(e.nzHeight) + "px;float: left;display: none;cursor:" + e.options.cursor + ";px solid " + e.options.borderColour + ";background-repeat: no-repeat;position: absolute;"), "window" == e.options.zoomType && (lensHeight = e.nzHeight < e.options.zoomWindowWidth / e.widthRatio ? e.nzHeight : String(e.options.zoomWindowHeight / e.heightRatio), lensWidth = e.largeWidth < e.options.zoomWindowWidth ? e.nzWidth : e.options.zoomWindowWidth / e.widthRatio, e.lensStyle = "background-position: 0px 0px;width: " + String(e.options.zoomWindowWidth / e.widthRatio) + "px;height: " + String(e.options.zoomWindowHeight / e.heightRatio) + "px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:" + e.options.lensOpacity + ";filter: alpha(opacity = " + 100 * e.options.lensOpacity + "); zoom:1;width:" + lensWidth + "px;height:" + lensHeight + "px;background-color:" + e.options.lensColour + ";cursor:" + e.options.cursor + ";border: " + e.options.lensBorderSize + "px solid " + e.options.lensBorderColour + ";background-repeat: no-repeat;position: absolute;"), e.tintStyle = "display: block;position: absolute;background-color: " + e.options.tintColour + ";filter:alpha(opacity=0);opacity: 0;width: " + e.nzWidth + "px;height: " + e.nzHeight + "px;", e.lensRound = "", "lens" == e.options.zoomType && (e.lensStyle = "background-position: 0px 0px;float: left;display: none;border: " + String(e.options.borderSize) + "px solid " + e.options.borderColour + ";width:" + String(e.options.lensSize) + "px;height:" + String(e.options.lensSize) + "px;background-repeat: no-repeat;position: absolute;"), "round" == e.options.lensShape && (e.lensRound = "border-top-left-radius: " + String(e.options.lensSize / 2 + e.options.borderSize) + "px;border-top-right-radius: " + String(e.options.lensSize / 2 + e.options.borderSize) + "px;border-bottom-left-radius: " + String(e.options.lensSize / 2 + e.options.borderSize) + "px;border-bottom-right-radius: " + String(e.options.lensSize / 2 + e.options.borderSize) + "px;"), e.zoomContainer = t('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:' + e.nzOffset.left + "px;top:" + e.nzOffset.top + "px;height:" + e.nzHeight + "px;width:" + e.nzWidth + 'px;"></div>'), t("body").append(e.zoomContainer), e.options.containLensZoom && "lens" == e.options.zoomType && e.zoomContainer.css("overflow", "hidden"), "inner" != e.options.zoomType && (e.zoomLens = t("<div class='zoomLens' style='" + e.lensStyle + e.lensRound + "'>&nbsp;</div>").appendTo(e.zoomContainer).click(function() {
                    e.$elem.trigger("click")
                })), e.options.tint && (e.tintContainer = t("<div/>").addClass("tintContainer"), e.zoomTint = t("<div class='zoomTint' style='" + e.tintStyle + "'></div>"), e.zoomLens.wrap(e.tintContainer), e.zoomTintcss = e.zoomLens.after(e.zoomTint), e.zoomTintImage = t('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' + e.nzWidth + "px; height: " + e.nzHeight + 'px;" src="' + e.imageSrc + '">').appendTo(e.zoomLens).click(function() {
                    e.$elem.trigger("click")
                })), isNaN(e.options.zoomWindowPosition) ? e.zoomWindow = t("<div style='z-index:999;left:" + e.windowOffsetLeft + "px;top:" + e.windowOffsetTop + "px;" + e.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function() {
                    e.$elem.trigger("click")
                }) : e.zoomWindow = t("<div style='z-index:999;left:" + e.windowOffsetLeft + "px;top:" + e.windowOffsetTop + "px;" + e.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo(e.zoomContainer).click(function() {
                    e.$elem.trigger("click")
                }), e.zoomWindowContainer = t("<div/>").addClass("zoomWindowContainer").css("width", e.options.zoomWindowWidth), e.zoomWindow.wrap(e.zoomWindowContainer), "lens" == e.options.zoomType && e.zoomLens.css({
                    backgroundImage: "url('" + e.imageSrc + "')"
                }), "window" == e.options.zoomType && e.zoomWindow.css({
                    backgroundImage: "url('" + e.imageSrc + "')"
                }), "inner" == e.options.zoomType && e.zoomWindow.css({
                    backgroundImage: "url('" + e.imageSrc + "')"
                }), e.$elem.bind("touchmove", function(t) {
                    t.preventDefault(), e.setPosition(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])
                }), e.zoomContainer.bind("touchmove", function(t) {
                    "inner" == e.options.zoomType && e.showHideWindow("show"), t.preventDefault(), e.setPosition(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])
                }), e.zoomContainer.bind("touchend", function(t) {
                    e.showHideWindow("hide"), e.options.showLens && e.showHideLens("hide"), e.options.tint && e.showHideTint("hide")
                }), e.$elem.bind("touchend", function(t) {
                    e.showHideWindow("hide"), e.options.showLens && e.showHideLens("hide"), e.options.tint && e.showHideTint("hide")
                }), e.options.showLens && (e.zoomLens.bind("touchmove", function(t) {
                    t.preventDefault(), e.setPosition(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])
                }), e.zoomLens.bind("touchend", function(t) {
                    e.showHideWindow("hide"), e.options.showLens && e.showHideLens("hide"), e.options.tint && e.showHideTint("hide")
                })), e.$elem.bind("mousemove", function(t) {
                    0 == e.overWindow && e.setElements("show"), e.lastX === t.clientX && e.lastY === t.clientY || (e.setPosition(t), e.currentLoc = t), e.lastX = t.clientX, e.lastY = t.clientY
                }), e.zoomContainer.bind("mousemove", function(t) {
                    0 == e.overWindow && e.setElements("show"), e.lastX === t.clientX && e.lastY === t.clientY || (e.setPosition(t), e.currentLoc = t), e.lastX = t.clientX, e.lastY = t.clientY
                }), "inner" != e.options.zoomType && e.zoomLens.bind("mousemove", function(t) {
                    e.lastX === t.clientX && e.lastY === t.clientY || (e.setPosition(t), e.currentLoc = t), e.lastX = t.clientX, e.lastY = t.clientY
                }), e.options.tint && e.zoomTint.bind("mousemove", function(t) {
                    e.lastX === t.clientX && e.lastY === t.clientY || (e.setPosition(t), e.currentLoc = t), e.lastX = t.clientX, e.lastY = t.clientY
                }), "inner" == e.options.zoomType && e.zoomWindow.bind("mousemove", function(t) {
                    e.lastX === t.clientX && e.lastY === t.clientY || (e.setPosition(t), e.currentLoc = t), e.lastX = t.clientX, e.lastY = t.clientY
                }), e.zoomContainer.add(e.$elem).mouseenter(function() {
                    0 == e.overWindow && e.setElements("show")
                }).mouseleave(function() {
                    e.scrollLock || e.setElements("hide")
                }), "inner" != e.options.zoomType && e.zoomWindow.mouseenter(function() {
                    e.overWindow = !0, e.setElements("hide")
                }).mouseleave(function() {
                    e.overWindow = !1
                }), 1 != e.options.zoomLevel && e.changeZoomLevel(e.currentZoomLevel), e.minZoomLevel = e.options.minZoomLevel ? e.options.minZoomLevel : 2 * e.options.scrollZoomIncrement, e.options.scrollZoom && e.zoomContainer.add(e.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll", function(i) {
                    e.scrollLock = !0, clearTimeout(t.data(this, "timer")), t.data(this, "timer", setTimeout(function() {
                        e.scrollLock = !1
                    }, 250));
                    var o = i.originalEvent.wheelDelta || -1 * i.originalEvent.detail;
                    return i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault(), 0 < o / 120 ? e.currentZoomLevel >= e.minZoomLevel && e.changeZoomLevel(e.currentZoomLevel - e.options.scrollZoomIncrement) : e.options.maxZoomLevel ? e.currentZoomLevel <= e.options.maxZoomLevel && e.changeZoomLevel(parseFloat(e.currentZoomLevel) + e.options.scrollZoomIncrement) : e.changeZoomLevel(parseFloat(e.currentZoomLevel) + e.options.scrollZoomIncrement), !1
                })
            },
            setElements: function(t) {
                "show" == t && this.isWindowSet && ("inner" == this.options.zoomType && this.showHideWindow("show"), "window" == this.options.zoomType && this.showHideWindow("show"), this.options.showLens && this.showHideLens("show"), this.options.tint && this.showHideTint("show")), "hide" == t && ("window" == this.options.zoomType && this.showHideWindow("hide"), this.options.tint || this.showHideWindow("hide"), this.options.showLens && this.showHideLens("hide"), this.options.tint && this.showHideTint("hide"))
            },
            setPosition: function(t) {
                this.nzHeight = this.$elem.height(), this.nzWidth = this.$elem.width(), this.nzOffset = this.$elem.offset(), this.options.tint && (this.zoomTint.css({
                    top: 0
                }), this.zoomTint.css({
                    left: 0
                })), this.options.responsive && !this.options.scrollZoom && this.options.showLens && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.largeWidth < this.options.zoomWindowWidth ? this.nzHWidth : this.options.zoomWindowWidth / this.widthRatio, this.widthRatio = this.largeWidth / this.nzWidth, this.heightRatio = this.largeHeight / this.nzHeight, "lens" != this.options.zoomType && this.zoomLens.css({
                    width: String(this.options.zoomWindowWidth / this.widthRatio) + "px",
                    height: String(this.options.zoomWindowHeight / this.heightRatio) + "px"
                }), "lens" == this.options.zoomType && this.zoomLens.css({
                    width: String(this.options.lensSize) + "px",
                    height: String(this.options.lensSize) + "px"
                })), this.zoomContainer.css({
                    top: this.nzOffset.top
                }), this.zoomContainer.css({
                    left: this.nzOffset.left
                }), this.mouseLeft = parseInt(t.pageX - this.nzOffset.left), this.mouseTop = parseInt(t.pageY - this.nzOffset.top), "window" == this.options.zoomType && (this.Etoppos = this.mouseTop < this.zoomLens.height() / 2, this.Eboppos = this.mouseTop > this.nzHeight - this.zoomLens.height() / 2 - 2 * this.options.lensBorderSize, this.Eloppos = this.mouseLeft < 0 + this.zoomLens.width() / 2, this.Eroppos = this.mouseLeft > this.nzWidth - this.zoomLens.width() / 2 - 2 * this.options.lensBorderSize), "inner" == this.options.zoomType && (this.Etoppos = this.mouseTop < this.nzHeight / 2 / this.heightRatio, this.Eboppos = this.mouseTop > this.nzHeight - this.nzHeight / 2 / this.heightRatio, this.Eloppos = this.mouseLeft < 0 + this.nzWidth / 2 / this.widthRatio, this.Eroppos = this.mouseLeft > this.nzWidth - this.nzWidth / 2 / this.widthRatio - 2 * this.options.lensBorderSize), 0 >= this.mouseLeft || 0 > this.mouseTop || this.mouseLeft > this.nzWidth || this.mouseTop > this.nzHeight ? this.setElements("hide") : (this.options.showLens && (this.lensLeftPos = String(this.mouseLeft - this.zoomLens.width() / 2), this.lensTopPos = String(this.mouseTop - this.zoomLens.height() / 2)), this.Etoppos && (this.lensTopPos = 0), this.Eloppos && (this.tintpos = this.lensLeftPos = this.windowLeftPos = 0), "window" == this.options.zoomType && (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)), "inner" == this.options.zoomType && (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.nzWidth - 2 * this.options.lensBorderSize)), "lens" == this.options.zoomType && (this.windowLeftPos = String(-1 * ((t.pageX - this.nzOffset.left) * this.widthRatio - this.zoomLens.width() / 2)), this.windowTopPos = String(-1 * ((t.pageY - this.nzOffset.top) * this.heightRatio - this.zoomLens.height() / 2)), this.zoomLens.css({
                    backgroundPosition: this.windowLeftPos + "px " + this.windowTopPos + "px"
                }), this.changeBgSize && (this.nzHeight > this.nzWidth ? ("lens" == this.options.zoomType && this.zoomLens.css({
                    "background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px"
                }), this.zoomWindow.css({
                    "background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px"
                })) : ("lens" == this.options.zoomType && this.zoomLens.css({
                    "background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px"
                }), this.zoomWindow.css({
                    "background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px"
                })), this.changeBgSize = !1), this.setWindowPostition(t)), this.options.tint && this.setTintPosition(t), "window" == this.options.zoomType && this.setWindowPostition(t), "inner" == this.options.zoomType && this.setWindowPostition(t), this.options.showLens && (this.fullwidth && "lens" != this.options.zoomType && (this.lensLeftPos = 0), this.zoomLens.css({
                    left: this.lensLeftPos + "px",
                    top: this.lensTopPos + "px"
                })))
            },
            showHideWindow: function(t) {
                "show" != t || this.isWindowActive || (this.options.zoomWindowFadeIn ? this.zoomWindow.stop(!0, !0, !1).fadeIn(this.options.zoomWindowFadeIn) : this.zoomWindow.show(), this.isWindowActive = !0), "hide" == t && this.isWindowActive && (this.options.zoomWindowFadeOut ? this.zoomWindow.stop(!0, !0).fadeOut(this.options.zoomWindowFadeOut) : this.zoomWindow.hide(), this.isWindowActive = !1)
            },
            showHideLens: function(t) {
                "show" != t || this.isLensActive || (this.options.lensFadeIn ? this.zoomLens.stop(!0, !0, !1).fadeIn(this.options.lensFadeIn) : this.zoomLens.show(), this.isLensActive = !0), "hide" == t && this.isLensActive && (this.options.lensFadeOut ? this.zoomLens.stop(!0, !0).fadeOut(this.options.lensFadeOut) : this.zoomLens.hide(), this.isLensActive = !1)
            },
            showHideTint: function(t) {
                "show" != t || this.isTintActive || (this.options.zoomTintFadeIn ? this.zoomTint.css({
                    opacity: this.options.tintOpacity
                }).animate().stop(!0, !0).fadeIn("slow") : (this.zoomTint.css({
                    opacity: this.options.tintOpacity
                }).animate(), this.zoomTint.show()), this.isTintActive = !0), "hide" == t && this.isTintActive && (this.options.zoomTintFadeOut ? this.zoomTint.stop(!0, !0).fadeOut(this.options.zoomTintFadeOut) : this.zoomTint.hide(), this.isTintActive = !1)
            },
            setLensPostition: function(t) {},
            setWindowPostition: function(e) {
                var i = this;
                if (isNaN(i.options.zoomWindowPosition)) i.externalContainer = t("#" + i.options.zoomWindowPosition), i.externalContainerWidth = i.externalContainer.width(), i.externalContainerHeight = i.externalContainer.height(), i.externalContainerOffset = i.externalContainer.offset(), i.windowOffsetTop = i.externalContainerOffset.top, i.windowOffsetLeft = i.externalContainerOffset.left;
                else switch (i.options.zoomWindowPosition) {
                    case 1:
                        i.windowOffsetTop = i.options.zoomWindowOffety, i.windowOffsetLeft = +i.nzWidth;
                        break;
                    case 2:
                        i.options.zoomWindowHeight > i.nzHeight && (i.windowOffsetTop = -1 * (i.options.zoomWindowHeight / 2 - i.nzHeight / 2), i.windowOffsetLeft = i.nzWidth);
                        break;
                    case 3:
                        i.windowOffsetTop = i.nzHeight - i.zoomWindow.height() - 2 * i.options.borderSize, i.windowOffsetLeft = i.nzWidth;
                        break;
                    case 4:
                        i.windowOffsetTop = i.nzHeight, i.windowOffsetLeft = i.nzWidth;
                        break;
                    case 5:
                        i.windowOffsetTop = i.nzHeight, i.windowOffsetLeft = i.nzWidth - i.zoomWindow.width() - 2 * i.options.borderSize;
                        break;
                    case 6:
                        i.options.zoomWindowHeight > i.nzHeight && (i.windowOffsetTop = i.nzHeight, i.windowOffsetLeft = -1 * (i.options.zoomWindowWidth / 2 - i.nzWidth / 2 + 2 * i.options.borderSize));
                        break;
                    case 7:
                        i.windowOffsetTop = i.nzHeight, i.windowOffsetLeft = 0;
                        break;
                    case 8:
                        i.windowOffsetTop = i.nzHeight, i.windowOffsetLeft = -1 * (i.zoomWindow.width() + 2 * i.options.borderSize);
                        break;
                    case 9:
                        i.windowOffsetTop = i.nzHeight - i.zoomWindow.height() - 2 * i.options.borderSize, i.windowOffsetLeft = -1 * (i.zoomWindow.width() + 2 * i.options.borderSize);
                        break;
                    case 10:
                        i.options.zoomWindowHeight > i.nzHeight && (i.windowOffsetTop = -1 * (i.options.zoomWindowHeight / 2 - i.nzHeight / 2), i.windowOffsetLeft = -1 * (i.zoomWindow.width() + 2 * i.options.borderSize));
                        break;
                    case 11:
                        i.windowOffsetTop = i.options.zoomWindowOffety, i.windowOffsetLeft = -1 * (i.zoomWindow.width() + 2 * i.options.borderSize);
                        break;
                    case 12:
                        i.windowOffsetTop = -1 * (i.zoomWindow.height() + 2 * i.options.borderSize), i.windowOffsetLeft = -1 * (i.zoomWindow.width() + 2 * i.options.borderSize);
                        break;
                    case 13:
                        i.windowOffsetTop = -1 * (i.zoomWindow.height() + 2 * i.options.borderSize), i.windowOffsetLeft = 0;
                        break;
                    case 14:
                        i.options.zoomWindowHeight > i.nzHeight && (i.windowOffsetTop = -1 * (i.zoomWindow.height() + 2 * i.options.borderSize), i.windowOffsetLeft = -1 * (i.options.zoomWindowWidth / 2 - i.nzWidth / 2 + 2 * i.options.borderSize));
                        break;
                    case 15:
                        i.windowOffsetTop = -1 * (i.zoomWindow.height() + 2 * i.options.borderSize), i.windowOffsetLeft = i.nzWidth - i.zoomWindow.width() - 2 * i.options.borderSize;
                        break;
                    case 16:
                        i.windowOffsetTop = -1 * (i.zoomWindow.height() + 2 * i.options.borderSize), i.windowOffsetLeft = i.nzWidth;
                        break;
                    default:
                        i.windowOffsetTop = i.options.zoomWindowOffety, i.windowOffsetLeft = i.nzWidth
                }
                i.isWindowSet = !0, i.windowOffsetTop += i.options.zoomWindowOffety, i.windowOffsetLeft += i.options.zoomWindowOffetx, i.zoomWindow.css({
                    top: i.windowOffsetTop
                }), i.zoomWindow.css({
                    left: i.windowOffsetLeft
                }), "inner" == i.options.zoomType && (i.zoomWindow.css({
                    top: 0
                }), i.zoomWindow.css({
                    left: 0
                })), i.windowLeftPos = String(-1 * ((e.pageX - i.nzOffset.left) * i.widthRatio - i.zoomWindow.width() / 2)), i.windowTopPos = String(-1 * ((e.pageY - i.nzOffset.top) * i.heightRatio - i.zoomWindow.height() / 2)), i.Etoppos && (i.windowTopPos = 0), i.Eloppos && (i.windowLeftPos = 0), i.Eboppos && (i.windowTopPos = -1 * (i.largeHeight / i.currentZoomLevel - i.zoomWindow.height())), i.Eroppos && (i.windowLeftPos = -1 * (i.largeWidth / i.currentZoomLevel - i.zoomWindow.width())), i.fullheight && (i.windowTopPos = 0), i.fullwidth && (i.windowLeftPos = 0), "window" != i.options.zoomType && "inner" != i.options.zoomType || (1 == i.zoomLock && (1 >= i.widthRatio && (i.windowLeftPos = 0), 1 >= i.heightRatio && (i.windowTopPos = 0)), i.largeHeight < i.options.zoomWindowHeight && (i.windowTopPos = 0), i.largeWidth < i.options.zoomWindowWidth && (i.windowLeftPos = 0), i.options.easing ? (i.xp || (i.xp = 0), i.yp || (i.yp = 0), i.loop || (i.loop = setInterval(function() {
                    i.xp += (i.windowLeftPos - i.xp) / i.options.easingAmount, i.yp += (i.windowTopPos - i.yp) / i.options.easingAmount, i.scrollingLock ? (clearInterval(i.loop), i.xp = i.windowLeftPos, i.yp = i.windowTopPos, i.xp = -1 * ((e.pageX - i.nzOffset.left) * i.widthRatio - i.zoomWindow.width() / 2), i.yp = -1 * ((e.pageY - i.nzOffset.top) * i.heightRatio - i.zoomWindow.height() / 2), i.changeBgSize && (i.nzHeight > i.nzWidth ? ("lens" == i.options.zoomType && i.zoomLens.css({
                        "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                    }), i.zoomWindow.css({
                        "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                    })) : ("lens" != i.options.zoomType && i.zoomLens.css({
                        "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvalueheight + "px"
                    }), i.zoomWindow.css({
                        "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
                    })), i.changeBgSize = !1), i.zoomWindow.css({
                        backgroundPosition: i.windowLeftPos + "px " + i.windowTopPos + "px"
                    }), i.scrollingLock = !1, i.loop = !1) : (i.changeBgSize && (i.nzHeight > i.nzWidth ? ("lens" == i.options.zoomType && i.zoomLens.css({
                        "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                    }), i.zoomWindow.css({
                        "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                    })) : ("lens" != i.options.zoomType && i.zoomLens.css({
                        "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
                    }), i.zoomWindow.css({
                        "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
                    })), i.changeBgSize = !1), i.zoomWindow.css({
                        backgroundPosition: i.xp + "px " + i.yp + "px"
                    }))
                }, 16))) : (i.changeBgSize && (i.nzHeight > i.nzWidth ? ("lens" == i.options.zoomType && i.zoomLens.css({
                    "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                }), i.zoomWindow.css({
                    "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                })) : ("lens" == i.options.zoomType && i.zoomLens.css({
                    "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
                }), i.largeHeight / i.newvaluewidth < i.options.zoomWindowHeight ? i.zoomWindow.css({
                    "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
                }) : i.zoomWindow.css({
                    "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                })), i.changeBgSize = !1), i.zoomWindow.css({
                    backgroundPosition: i.windowLeftPos + "px " + i.windowTopPos + "px"
                })))
            },
            setTintPosition: function(t) {
                this.nzOffset = this.$elem.offset(), this.tintpos = String(-1 * (t.pageX - this.nzOffset.left - this.zoomLens.width() / 2)), this.tintposy = String(-1 * (t.pageY - this.nzOffset.top - this.zoomLens.height() / 2)), this.Etoppos && (this.tintposy = 0), this.Eloppos && (this.tintpos = 0), this.Eboppos && (this.tintposy = -1 * (this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize)), this.Eroppos && (this.tintpos = -1 * (this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)), this.options.tint && (this.fullheight && (this.tintposy = 0), this.fullwidth && (this.tintpos = 0), this.zoomTintImage.css({
                    left: this.tintpos + "px"
                }), this.zoomTintImage.css({
                    top: this.tintposy + "px"
                }))
            },
            swaptheimage: function(e, i) {
                var o = this,
                    n = new Image;
                o.options.loadingIcon && (o.spinner = t("<div style=\"background: url('" + o.options.loadingIcon + "') no-repeat center;height:" + o.nzHeight + "px;width:" + o.nzWidth + 'px;z-index: 2000;position: absolute; background-position: center center;"></div>'), o.$elem.after(o.spinner)), o.options.onImageSwap(o.$elem), n.onload = function() {
                    o.largeWidth = n.width, o.largeHeight = n.height, o.zoomImage = i, o.zoomWindow.css({
                        "background-size": o.largeWidth + "px " + o.largeHeight + "px"
                    }), o.swapAction(e, i)
                }, n.src = i
            },
            swapAction: function(e, i) {
                var o = this,
                    n = new Image;
                if (n.onload = function() {
                        o.nzHeight = n.height, o.nzWidth = n.width, o.options.onImageSwapComplete(o.$elem), o.doneCallback()
                    }, n.src = e, o.currentZoomLevel = o.options.zoomLevel, o.options.maxZoomLevel = !1, "lens" == o.options.zoomType && o.zoomLens.css({
                        backgroundImage: "url('" + i + "')"
                    }), "window" == o.options.zoomType && o.zoomWindow.css({
                        backgroundImage: "url('" + i + "')"
                    }), "inner" == o.options.zoomType && o.zoomWindow.css({
                        backgroundImage: "url('" + i + "')"
                    }), o.currentImage = i, o.options.imageCrossfade) {
                    var s = o.$elem,
                        a = s.clone();
                    o.$elem.attr("src", e), o.$elem.after(a), a.stop(!0).fadeOut(o.options.imageCrossfade, function() {
                        t(this).remove()
                    }), s.fadeIn(o.options.imageCrossfade), o.options.tint && (s = o.zoomTintImage, a = s.clone(), o.zoomTintImage.attr("src", i), o.zoomTintImage.after(a), a.stop(!0).fadeOut(o.options.imageCrossfade, function() {
                        t(this).remove()
                    }), s.fadeIn(o.options.imageCrossfade), o.zoomTint.css({
                        height: o.$elem.height()
                    }))
                } else o.$elem.attr("src", e), o.options.tint && (o.zoomTintImage.attr("src", i), o.zoomTintImage.attr("height", o.$elem.height()), o.zoomTintImage.css({
                    height: o.$elem.height()
                }), o.zoomTint.css({
                    height: o.$elem.height()
                }));
                o.options.constrainType && ("height" == o.options.constrainType && (o.options.imageCrossfade ? (o.zoomWrap.css("height", o.options.constrainSize), o.zoomWrap.css("width", "auto")) : (o.$elem.css("height", o.options.constrainSize), o.$elem.css("width", "auto")), o.zoomTint && (o.zoomTintImage.css("height", o.options.constrainSize), o.zoomTintImage.css("width", "auto"))), "width" == o.options.constrainType && (o.zoomContainer.css("height", "auto"), o.zoomContainer.css("width", o.options.constrainSize), o.options.imageCrossfade ? (o.zoomWrap.css("height", "auto"), o.zoomWrap.css("width", o.options.constrainSize)) : (o.$elem.css("height", "auto"), o.$elem.css("width", o.options.constrainSize)), o.zoomTint && (o.tintContainer.css("height", "auto"), o.tintContainer.css("width", o.options.constrainSize), o.zoomTintImage.css("height", "auto"), o.zoomTintImage.css("width", o.options.constrainSize))))
            },
            doneCallback: function() {
                this.options.loadingIcon && this.spinner.hide(), this.nzOffset = this.$elem.offset(), this.nzWidth = this.$elem.width(), this.nzHeight = this.$elem.height(), this.currentZoomLevel = this.options.zoomLevel, this.widthRatio = this.largeWidth / this.nzWidth, this.heightRatio = this.largeHeight / this.nzHeight, "window" == this.options.zoomType && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.largeWidth < this.options.zoomWindowWidth ? this.nzHWidth : this.options.zoomWindowWidth / this.widthRatio, this.zoomLens && (this.zoomLens.css("width", lensWidth), this.zoomLens.css("height", lensHeight)))
            },
            getCurrentImage: function() {
                return this.zoomImage
            },
            getGalleryList: function() {
                var e = this;
                return e.gallerylist = [], e.options.gallery ? t("#" + e.options.gallery + " a").each(function() {
                    var i = "";
                    t(this).data("zoom-image") ? i = t(this).data("zoom-image") : t(this).data("image") && (i = t(this).data("image")), i == e.zoomImage ? e.gallerylist.unshift({
                        href: "" + i,
                        title: t(this).find("img").attr("title")
                    }) : e.gallerylist.push({
                        href: "" + i,
                        title: t(this).find("img").attr("title")
                    })
                }) : e.gallerylist.push({
                    href: "" + e.zoomImage,
                    title: t(this).find("img").attr("title")
                }), e.gallerylist
            },
            changeZoomLevel: function(t) {
                this.scrollingLock = !0, this.newvalue = parseFloat(t).toFixed(2), newvalue = parseFloat(t).toFixed(2), maxheightnewvalue = this.largeHeight / (this.options.zoomWindowHeight / this.nzHeight * this.nzHeight), maxwidthtnewvalue = this.largeWidth / (this.options.zoomWindowWidth / this.nzWidth * this.nzWidth), "inner" != this.options.zoomType && (maxheightnewvalue <= newvalue ? (this.heightRatio = this.largeHeight / maxheightnewvalue / this.nzHeight, this.newvalueheight = maxheightnewvalue, this.fullheight = !0) : (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue, this.fullheight = !1), maxwidthtnewvalue <= newvalue ? (this.widthRatio = this.largeWidth / maxwidthtnewvalue / this.nzWidth, this.newvaluewidth = maxwidthtnewvalue, this.fullwidth = !0) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1), "lens" == this.options.zoomType && (maxheightnewvalue <= newvalue ? (this.fullwidth = !0, this.newvaluewidth = maxheightnewvalue) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1))), "inner" == this.options.zoomType && (maxheightnewvalue = parseFloat(this.largeHeight / this.nzHeight).toFixed(2), maxwidthtnewvalue = parseFloat(this.largeWidth / this.nzWidth).toFixed(2), newvalue > maxheightnewvalue && (newvalue = maxheightnewvalue), newvalue > maxwidthtnewvalue && (newvalue = maxwidthtnewvalue), maxheightnewvalue <= newvalue ? (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue > maxheightnewvalue ? maxheightnewvalue : newvalue, this.fullheight = !0) : (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue > maxheightnewvalue ? maxheightnewvalue : newvalue, this.fullheight = !1), maxwidthtnewvalue <= newvalue ? (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue > maxwidthtnewvalue ? maxwidthtnewvalue : newvalue, this.fullwidth = !0) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1)), scrcontinue = !1, "inner" == this.options.zoomType && (this.nzWidth > this.nzHeight && (this.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, this.fullwidth = this.fullheight = !0)), this.nzHeight > this.nzWidth && (this.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, this.fullwidth = this.fullheight = !0))), "inner" != this.options.zoomType && (scrcontinue = !0), scrcontinue && (this.zoomLock = 0, this.changeZoom = !0, this.options.zoomWindowHeight / this.heightRatio <= this.nzHeight && (this.currentZoomLevel = this.newvalueheight, "lens" != this.options.zoomType && "inner" != this.options.zoomType && (this.changeBgSize = !0, this.zoomLens.css({
                    height: String(this.options.zoomWindowHeight / this.heightRatio) + "px"
                })), "lens" == this.options.zoomType || "inner" == this.options.zoomType) && (this.changeBgSize = !0), this.options.zoomWindowWidth / this.widthRatio <= this.nzWidth && ("inner" != this.options.zoomType && this.newvaluewidth > this.newvalueheight && (this.currentZoomLevel = this.newvaluewidth), "lens" != this.options.zoomType && "inner" != this.options.zoomType && (this.changeBgSize = !0, this.zoomLens.css({
                    width: String(this.options.zoomWindowWidth / this.widthRatio) + "px"
                })), "lens" == this.options.zoomType || "inner" == this.options.zoomType) && (this.changeBgSize = !0), "inner" == this.options.zoomType && (this.changeBgSize = !0, this.nzWidth > this.nzHeight && (this.currentZoomLevel = this.newvaluewidth), this.nzHeight > this.nzWidth && (this.currentZoomLevel = this.newvaluewidth))), this.setPosition(this.currentLoc)
            },
            closeAll: function() {
                self.zoomWindow && self.zoomWindow.hide(), self.zoomLens && self.zoomLens.hide(), self.zoomTint && self.zoomTint.hide()
            }
        };
        t.fn.elevateZoom = function(e) {
            return this.each(function() {
                var i = Object.create(n);
                i.init(e, this), t.data(this, "elevateZoom", i)
            })
        }, t.fn.elevateZoom.options = {
            zoomActivation: "hover",
            preloading: 1,
            zoomLevel: 1,
            scrollZoom: !1,
            scrollZoomIncrement: .1,
            minZoomLevel: !1,
            maxZoomLevel: !1,
            easing: !1,
            easingAmount: 12,
            lensSize: 200,
            zoomWindowWidth: 400,
            zoomWindowHeight: 400,
            zoomWindowOffetx: 0,
            zoomWindowOffety: 0,
            zoomWindowPosition: 1,
            zoomWindowBgColour: "#fff",
            lensFadeIn: !1,
            lensFadeOut: !1,
            debug: !1,
            zoomWindowFadeIn: !1,
            zoomWindowFadeOut: !1,
            zoomWindowAlwaysShow: !1,
            zoomTintFadeIn: !1,
            zoomTintFadeOut: !1,
            borderSize: 4,
            showLens: !0,
            borderColour: "#888",
            lensBorderSize: 1,
            lensBorderColour: "#000",
            lensShape: "square",
            zoomType: "window",
            containLensZoom: !1,
            lensColour: "white",
            lensOpacity: .4,
            lenszoom: !1,
            tint: !1,
            tintColour: "#333",
            tintOpacity: .4,
            gallery: !1,
            galleryActiveClass: "zoomGalleryActive",
            imageCrossfade: !1,
            constrainType: !1,
            constrainSize: !1,
            loadingIcon: !1,
            cursor: "default",
            responsive: !0,
            onComplete: t.noop,
            onZoomedImageLoaded: function() {},
            onImageSwap: t.noop,
            onImageSwapComplete: t.noop
        }
    }(jQuery, window, document),
    function(t) {
        var e = function(t, e, i) {
            "use strict";
            var o, n;
            if (function() {
                    var e, i = {
                        lazyClass: "lazyload",
                        loadedClass: "lazyloaded",
                        loadingClass: "lazyloading",
                        preloadClass: "lazypreload",
                        errorClass: "lazyerror",
                        autosizesClass: "lazyautosizes",
                        srcAttr: "data-src",
                        srcsetAttr: "data-srcset",
                        sizesAttr: "data-sizes",
                        minSize: 40,
                        customMedia: {},
                        init: !0,
                        expFactor: 1.5,
                        hFac: .8,
                        loadMode: 2,
                        loadHidden: !0,
                        ricTimeout: 0,
                        throttleDelay: 125
                    };
                    n = t.lazySizesConfig || t.lazysizesConfig || {};
                    for (e in i) e in n || (n[e] = i[e])
                }(), !e || !e.getElementsByClassName) return {
                init: function() {},
                cfg: n,
                noSupport: !0
            };
            var s = e.documentElement,
                a = t.HTMLPictureElement,
                r = "addEventListener",
                l = "getAttribute",
                h = t[r].bind(t),
                d = t.setTimeout,
                c = t.requestAnimationFrame || d,
                p = t.requestIdleCallback,
                u = /^picture$/i,
                f = ["load", "error", "lazyincluded", "_lazyloaded"],
                m = {},
                g = Array.prototype.forEach,
                w = function(t, e) {
                    return m[e] || (m[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), m[e].test(t[l]("class") || "") && m[e]
                },
                v = function(t, e) {
                    w(t, e) || t.setAttribute("class", (t[l]("class") || "").trim() + " " + e)
                },
                y = function(t, e) {
                    var i;
                    (i = w(t, e)) && t.setAttribute("class", (t[l]("class") || "").replace(i, " "))
                },
                b = function(t, e, i) {
                    var o = i ? r : "removeEventListener";
                    i && b(t, e), f.forEach(function(i) {
                        t[o](i, e)
                    })
                },
                z = function(t, i, n, s, a) {
                    var r = e.createEvent("Event");
                    return n || (n = {}), n.instance = o, r.initEvent(i, !s, !a), r.detail = n, t.dispatchEvent(r), r
                },
                x = function(e, i) {
                    var o;
                    !a && (o = t.picturefill || n.pf) ? (i && i.src && !e[l]("srcset") && e.setAttribute("srcset", i.src), o({
                        reevaluate: !0,
                        elements: [e]
                    })) : i && i.src && (e.src = i.src)
                },
                C = function(t, e) {
                    return (getComputedStyle(t, null) || {})[e]
                },
                S = function(t, e, i) {
                    for (i = i || t.offsetWidth; i < n.minSize && e && !t._lazysizesWidth;) i = e.offsetWidth, e = e.parentNode;
                    return i
                },
                T = function() {
                    var t, i, o = [],
                        n = [],
                        s = o,
                        a = function() {
                            var e = s;
                            for (s = o.length ? n : o, t = !0, i = !1; e.length;) e.shift()();
                            t = !1
                        },
                        r = function(o, n) {
                            t && !n ? o.apply(this, arguments) : (s.push(o), i || (i = !0, (e.hidden ? d : c)(a)))
                        };
                    return r._lsFlush = a, r
                }(),
                j = function(t, e) {
                    return e ? function() {
                        T(t)
                    } : function() {
                        var e = this,
                            i = arguments;
                        T(function() {
                            t.apply(e, i)
                        })
                    }
                },
                W = function(t) {
                    var e, o = 0,
                        s = n.throttleDelay,
                        a = n.ricTimeout,
                        r = function() {
                            e = !1, o = i.now(), t()
                        },
                        l = p && a > 49 ? function() {
                            p(r, {
                                timeout: a
                            }), a !== n.ricTimeout && (a = n.ricTimeout)
                        } : j(function() {
                            d(r)
                        }, !0);
                    return function(t) {
                        var n;
                        (t = !0 === t) && (a = 33), e || (e = !0, (n = s - (i.now() - o)) < 0 && (n = 0), t || n < 9 ? l() : d(l, n))
                    }
                },
                k = function(t) {
                    var e, o, n = function() {
                            e = null, t()
                        },
                        s = function() {
                            var t = i.now() - o;
                            t < 99 ? d(s, 99 - t) : (p || n)(n)
                        };
                    return function() {
                        o = i.now(), e || (e = d(s, 99))
                    }
                },
                $ = function() {
                    var a, p, f, m, S, $, L, I, E, Q, P, H, A = /^img$/i,
                        D = /^iframe$/i,
                        R = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
                        _ = 0,
                        M = 0,
                        N = -1,
                        B = function(t) {
                            M--, (!t || M < 0 || !t.target) && (M = 0)
                        },
                        F = function(t) {
                            return null == H && (H = "hidden" == C(e.body, "visibility")), H || !("hidden" == C(t.parentNode, "visibility") && "hidden" == C(t, "visibility"))
                        },
                        G = function(t, i) {
                            var o, n = t,
                                a = F(t);
                            for (I -= i, P += i, E -= i, Q += i; a && (n = n.offsetParent) && n != e.body && n != s;)(a = (C(n, "opacity") || 1) > 0) && "visible" != C(n, "overflow") && (o = n.getBoundingClientRect(), a = Q > o.left && E < o.right && P > o.top - 1 && I < o.bottom + 1);
                            return a
                        },
                        U = function() {
                            var t, i, r, h, d, c, u, f, g, w, v, y, b = o.elements;
                            if ((m = n.loadMode) && M < 8 && (t = b.length)) {
                                for (i = 0, N++; i < t; i++)
                                    if (b[i] && !b[i]._lazyRace)
                                        if (!R || o.prematureUnveil && o.prematureUnveil(b[i])) tt(b[i]);
                                        else if ((f = b[i][l]("data-expand")) && (c = 1 * f) || (c = _), w || (w = !n.expand || n.expand < 1 ? s.clientHeight > 500 && s.clientWidth > 500 ? 500 : 370 : n.expand, o._defEx = w, v = w * n.expFactor, y = n.hFac, H = null, _ < v && M < 1 && N > 2 && m > 2 && !e.hidden ? (_ = v, N = 0) : _ = m > 1 && N > 1 && M < 6 ? w : 0), g !== c && ($ = innerWidth + c * y, L = innerHeight + c, u = -1 * c, g = c), r = b[i].getBoundingClientRect(), (P = r.bottom) >= u && (I = r.top) <= L && (Q = r.right) >= u * y && (E = r.left) <= $ && (P || Q || E || I) && (n.loadHidden || F(b[i])) && (p && M < 3 && !f && (m < 3 || N < 4) || G(b[i], c))) {
                                    if (tt(b[i]), d = !0, M > 9) break
                                } else !d && p && !h && M < 4 && N < 4 && m > 2 && (a[0] || n.preloadAfterLoad) && (a[0] || !f && (P || Q || E || I || "auto" != b[i][l](n.sizesAttr))) && (h = a[0] || b[i]);
                                h && !d && tt(h)
                            }
                        },
                        Z = W(U),
                        V = function(t) {
                            var e = t.target;
                            e._lazyCache ? delete e._lazyCache : (B(t), v(e, n.loadedClass), y(e, n.loadingClass), b(e, Y), z(e, "lazyloaded"))
                        },
                        q = j(V),
                        Y = function(t) {
                            q({
                                target: t.target
                            })
                        },
                        X = function(t, e) {
                            try {
                                t.contentWindow.location.replace(e)
                            } catch (i) {
                                t.src = e
                            }
                        },
                        K = function(t) {
                            var e, i = t[l](n.srcsetAttr);
                            (e = n.customMedia[t[l]("data-media") || t[l]("media")]) && t.setAttribute("media", e), i && t.setAttribute("srcset", i)
                        },
                        J = j(function(t, e, i, o, s) {
                            var a, r, h, c, p, m;
                            (p = z(t, "lazybeforeunveil", e)).defaultPrevented || (o && (i ? v(t, n.autosizesClass) : t.setAttribute("sizes", o)), r = t[l](n.srcsetAttr), a = t[l](n.srcAttr), s && (c = (h = t.parentNode) && u.test(h.nodeName || "")), m = e.firesLoad || "src" in t && (r || a || c), p = {
                                target: t
                            }, v(t, n.loadingClass), m && (clearTimeout(f), f = d(B, 2500), b(t, Y, !0)), c && g.call(h.getElementsByTagName("source"), K), r ? t.setAttribute("srcset", r) : a && !c && (D.test(t.nodeName) ? X(t, a) : t.src = a), s && (r || c) && x(t, {
                                src: a
                            })), t._lazyRace && delete t._lazyRace, y(t, n.lazyClass), T(function() {
                                var e = t.complete && t.naturalWidth > 1;
                                m && !e || (e && v(t, "ls-is-cached"), V(p), t._lazyCache = !0, d(function() {
                                    "_lazyCache" in t && delete t._lazyCache
                                }, 9)), "lazy" == t.loading && M--
                            }, !0)
                        }),
                        tt = function(t) {
                            if (!t._lazyRace) {
                                var e, i = A.test(t.nodeName),
                                    o = i && (t[l](n.sizesAttr) || t[l]("sizes")),
                                    s = "auto" == o;
                                (!s && p || !i || !t[l]("src") && !t.srcset || t.complete || w(t, n.errorClass) || !w(t, n.lazyClass)) && (e = z(t, "lazyunveilread").detail, s && O.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, M++, J(t, e, s, o, i))
                            }
                        },
                        et = k(function() {
                            n.loadMode = 3, Z()
                        }),
                        it = function() {
                            3 == n.loadMode && (n.loadMode = 2), et()
                        },
                        ot = function() {
                            p || (i.now() - S < 999 ? d(ot, 999) : (p = !0, n.loadMode = 3, Z(), h("scroll", it, !0)))
                        };
                    return {
                        _: function() {
                            S = i.now(), o.elements = e.getElementsByClassName(n.lazyClass), a = e.getElementsByClassName(n.lazyClass + " " + n.preloadClass), h("scroll", Z, !0), h("resize", Z, !0), h("pageshow", function(t) {
                                if (t.persisted) {
                                    var i = e.querySelectorAll("." + n.loadingClass);
                                    i.length && i.forEach && c(function() {
                                        i.forEach(function(t) {
                                            t.complete && tt(t)
                                        })
                                    })
                                }
                            }), t.MutationObserver ? new MutationObserver(Z).observe(s, {
                                childList: !0,
                                subtree: !0,
                                attributes: !0
                            }) : (s[r]("DOMNodeInserted", Z, !0), s[r]("DOMAttrModified", Z, !0), setInterval(Z, 999)), h("hashchange", Z, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(t) {
                                e[r](t, Z, !0)
                            }), /d$|^c/.test(e.readyState) ? ot() : (h("load", ot), e[r]("DOMContentLoaded", Z), d(ot, 2e4)), o.elements.length ? (U(), T._lsFlush()) : Z()
                        },
                        checkElems: Z,
                        unveil: tt,
                        _aLSL: it
                    }
                }(),
                O = function() {
                    var t, i = j(function(t, e, i, o) {
                            var n, s, a;
                            if (t._lazysizesWidth = o, o += "px", t.setAttribute("sizes", o), u.test(e.nodeName || ""))
                                for (s = 0, a = (n = e.getElementsByTagName("source")).length; s < a; s++) n[s].setAttribute("sizes", o);
                            i.detail.dataAttr || x(t, i.detail)
                        }),
                        o = function(t, e, o) {
                            var n, s = t.parentNode;
                            s && (o = S(t, s, o), (n = z(t, "lazybeforesizes", {
                                width: o,
                                dataAttr: !!e
                            })).defaultPrevented || (o = n.detail.width) && o !== t._lazysizesWidth && i(t, s, n, o))
                        },
                        s = k(function() {
                            var e, i = t.length;
                            if (i)
                                for (e = 0; e < i; e++) o(t[e])
                        });
                    return {
                        _: function() {
                            t = e.getElementsByClassName(n.autosizesClass), h("resize", s)
                        },
                        checkElems: s,
                        updateElem: o
                    }
                }(),
                L = function() {
                    !L.i && e.getElementsByClassName && (L.i = !0, O._(), $._())
                };
            return d(function() {
                n.init && L()
            }), o = {
                cfg: n,
                autoSizer: O,
                loader: $,
                init: L,
                uP: x,
                aC: v,
                rC: y,
                hC: w,
                fire: z,
                gW: S,
                rAF: T
            }
        }(t, t.document, Date);
        t.lazySizes = e, "object" == typeof module && module.exports && (module.exports = e)
    }("undefined" != typeof window ? window : {});

document.addEventListener('DOMContentLoaded', function () {
  if (typeof clarity === 'function') {
    clarity('set', 'page', window.location.pathname);
  }
});